//otp flow types
// export const OTP_SIGNUP_TYPE = "signUp";
// export const OTP_FORGOT_PASSWORD_TYPE = "forgotPassword";

//user statuses
// export const ACTIVE_USER_STATUS = "active";
// export const INACTIVE_USER_STATUS = "inactive";
// export const BLOCKED_USER_STATUS = "blocked";
// export const PENDING_USER_STATUS = "pending";

// mouth areas
export const UR_STR = "Upper Right";
export const UL_STR = "Upper Left";
export const LR_STR = "Lower Right";
export const LL_STR = "Lower Left";
export const FM_STR = "Full Mouth";
export const UA_STR = "Upper Arch";
export const LA_STR = "Lower Arch";

// mouth areas
export const UR_QUADRANT = "UR";
export const UL_QUADRANT = "UL";
export const LR_QUADRANT = "LR";
export const LL_QUADRANT = "LL";
export const UA_QUADRANT = "UA";
export const LA_QUADRANT = "LA";
export const FM_QUADRANT = "FM";

//static routes
export const PUBLIC_INITIAL_ROUTE = "/";
export const ADMIN_DASHBOARD_ROUTE = "/admin/dashboard";
export const DOCTOR_DASHBOARD_ROUTE = "/doctor/dashboard";
export const PRACTICE_DASHBOARD_ROUTE = "/practice/dashboard";

//pagination prams
export const PAGE_RANGE = 2;
export const PER_PAGE_COUNT = 15;

// treatment colors
export const TREATMENT_COLOR_ON_WATCH = "var(--hl-success)";
export const TREATMENT_COLOR_TX_PLAN = "var(--hl-pending)";
export const TREATMENT_COLOR_COMPLETED = "var(--hl-success)";
export const TREATMENT_COLOR_ONGOING = "var(--hl-accent)";
export const TREATMENT_COLOR_MONITORING = "var(--hl-warning)";

// generic
export const SUBSTRING_LIMIT = 30;

// uses statuses
export const USER_ACTIVE_STATUS = "active";
export const USER_INACTIVE_STATUS = "inactive";

// user roles
export const ADMIN_ROLE = "admin";
export const DOCTOR_ROLE = "doctor";
export const PATIENT_ROLE = "patient";
export const PRACTICE_ROLE = "practice";

// treatment statuses
export const TREATMENT_STATUS_ONGOING = "Ongoing Treatment";
export const TREATMENT_STATUS_COMPLETED = "Treatment Completed";
export const TREATMENT_STATUS_TX_PLAN = "Pending Treatment";
export const TREATMENT_STATUS_MONITORING = "Monitoring";

export const TREATMENT_STATUSES = [
  {
    label: TREATMENT_STATUS_ONGOING,
    value: TREATMENT_STATUS_ONGOING,
  },
  {
    label: TREATMENT_STATUS_COMPLETED,
    value: TREATMENT_STATUS_COMPLETED,
  },
  {
    label: TREATMENT_STATUS_TX_PLAN,
    value: TREATMENT_STATUS_TX_PLAN,
  },
];

// add / edit practices allowed fields
export const ADD_PRACTICE_ALLOWED_FIELDS = [
  "name",
  "email",
  "about",
  "address",
  "password",
  "phoneNumber",
  "bookingLink",
  "appointmentRequestEmailEnabled",
  "appointmentRequestEmail",
  "connectorType",
  "locationId",
  "organizationId",
  "bridgeConsumerId",
  "openDentalCustomerKey",
  "openDentalClinicScopingEnabled",
  "chatbotEnabled",
  "txPlanViewEnabled",
  "shareTxPlanCostInfo",
  "txPlanSummaryEnabled",
  "txCategoriesEnabled",
  "shareLatestTxPlanOnly",
  "insuranceEstimatesEnabled",
  "tcDashboardEnabled",
  "portalPreviewEnabled",
  "attributedMetricsEnabled",
  "impactDigestEnabled",
  "impactDigestSendWeekday",
  "impactDigestSendHour",
  "impactDigestEmail",
  "appointmentInviteSmsEnabled",
  "reactivationActiveTxPlanOnly",
  "treatmentApptCheckEnabled",
  "hygieneCodes",
  "voiceCallingEnabled",
  "verifiedCallerIdNumber",
  "inboundRedirectNumber",
  "portfolioGalleryPath",
  "logoUrl",
  "timezone",
];
export const EDIT_PRACTICE_ALLOWED_FIELDS = [
  "name",
  "about",
  "address",
  "phoneNumber",
  "bookingLink",
  "appointmentRequestEmailEnabled",
  "appointmentRequestEmail",
  "chatbotEnabled",
  "txPlanViewEnabled",
  "shareTxPlanCostInfo",
  "txPlanSummaryEnabled",
  "txCategoriesEnabled",
  "shareLatestTxPlanOnly",
  "insuranceEstimatesEnabled",
  "tcDashboardEnabled",
  "portalPreviewEnabled",
  "attributedMetricsEnabled",
  "impactDigestEnabled",
  "impactDigestSendWeekday",
  "impactDigestSendHour",
  "impactDigestEmail",
  "appointmentInviteSmsEnabled",
  "reactivationActiveTxPlanOnly",
  "treatmentApptCheckEnabled",
  "hygieneCodes",
  "voiceCallingEnabled",
  "verifiedCallerIdNumber",
  "inboundRedirectNumber",
  "portfolioGalleryPath",
  "logoUrl",
  "connectorType",
  "locationId",
  "organizationId",
  "bridgeConsumerId",
  "openDentalCustomerKey",
  "openDentalClinicScopingEnabled",
  "timezone",
];

// add / edit doctors allowed fields
export const ADD_DOCTORS_ALLOWED_FIELDS = [
  "email",
  "about",
  "password",
  "lastName",
  "firstName",
  "practiceIds",
  "phoneNumber",
];
export const EDIT_DOCTORS_ALLOWED_FIELDS = [
  "email",
  "about",
  "lastName",
  "firstName",
  "practiceIds",
  "phoneNumber",
  "insightsEnabled",
  "debugToolsEnabled",
  "debugModeEnabled",
  "healinkImpactEnabled",
];
// views types
export const LIST_VIEW = "LIST_VIEW";
export const TREATMENTS_VIEW = "TREATMENTS_VIEW";

// admin api endpoints
export const LOGOUT_URL = "/auth/logout";
export const ADMIN_LOGIN_URL = "/admin/login";
export const ADMIN_RESEND_OTP_URL = "/admin/resendOtp";
export const ADMIN_VERIFY_OTP_URL = "/admin/verifyOtp";
export const ADMIN_UPDATE_DOCTOR_URL = "/doctor/profileUpdate";
export const ADMIN_RESET_PASSWORD_URL = "/admin/resetPassword";
export const ADMIN_CREATE_DOCTOR_URL = "/doctor/doctorCreation";
export const ADMIN_GET_ALL_DOCTORS_URL = "/doctor/getAllDoctors";
export const ADMIN_FORGOT_PASSWORD_URL = "/admin/forgetPassword";
export const ADMIN_DASHBOARD_STATS_URL = "/admin/adminDashboard";
export const ADMIN_CREATE_PRACTICE_URL = "/practice/createAccount";
export const ADMIN_DELETE_PRACTICE_URL = "/practice/removePractice";
export const ADMIN_GET_ALL_PRACTICES_URL = "/practice/getAllPractices";
export const ADMIN_DELETE_PATIENT_URL = "/patient";
export const ADMIN_HISTORICAL_SYNC_LAUNCH_URL = "/admin/historical-sync/launch";
export const ADMIN_HISTORICAL_SYNC_STATUS_URL = "/admin/historical-sync/status";
export const ADMIN_REACTIVATION_CAMPAIGN_URL = "/admin/reactivation/campaign";
export const ADMIN_EDIT_PRACTICE_URL = "/practice/practiceProfileUpdate";
export const ADMIN_GET_FILTERED_PRACTICES_URL =
  "/practice/getAllFilteredDoctorPractices";

// admin financing options endpoints (per practice)
export const ADMIN_LIST_FINANCING_OPTIONS_URL = (practiceId) =>
  `/financing/practices/${practiceId}/options`;
export const ADMIN_CREATE_FINANCING_OPTION_URL = (practiceId) =>
  `/financing/practices/${practiceId}/options`;
export const ADMIN_UPDATE_FINANCING_OPTION_URL = (practiceId, id) =>
  `/financing/practices/${practiceId}/options/${id}`;
export const ADMIN_DELETE_FINANCING_OPTION_URL = (practiceId, id) =>
  `/financing/practices/${practiceId}/options/${id}`;

export const ADMIN_INSURANCE_PLAN_BLACKLIST_URL = (practiceId) =>
  `/admin/practice/${practiceId}/insurance-plan-blacklist`;
export const ADMIN_INSURANCE_PLAN_AUDIT_URL = (practiceId) =>
  `/admin/practice/${practiceId}/insurance-plan-audit`;
export const ADMIN_RECALL_AUDIT_URL = (practiceId) =>
  `/admin/practice/${practiceId}/recall-audit`;

// admin financing partners endpoints (global registry)
export const ADMIN_LIST_FINANCING_PARTNERS_URL = "/financing/partners";
export const ADMIN_CREATE_FINANCING_PARTNER_URL = "/financing/partners";
export const ADMIN_UPDATE_FINANCING_PARTNER_URL = (id) =>
  `/financing/partners/${id}`;
export const ADMIN_DELETE_FINANCING_PARTNER_URL = (id) =>
  `/financing/partners/${id}`;

// doctor api endpoints
export const DOCTOR_LOGIN_URL = "/doctor/doctorLogin";
export const DOCTOR_SELECT_PRACTICE_URL = "/doctor/selectPractice";
export const DOCTOR_RESEND_OTP_URL = "/doctor/resendOtp";
export const DOCTOR_VERIFY_OTP_URL = "/doctor/verifyOtp";
export const DOCTOR_ADD_VISIT_URL = "/record/createVisit";
export const DOCTOR_ADD_PATIENT_URL = "/patient/patientCreation";
export const DOCTOR_DASHBOARD_STATS_URL = "/doctor/doctorDashboard";
export const OFFICE_DASHBOARD_MANIFEST_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/office-dashboard/manifest`;
export const OFFICE_DASHBOARD_PATIENTS_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/office-dashboard/patients`;
export const OFFICE_DASHBOARD_KPIS_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/office-dashboard/kpis`;
export const PRACTICE_IMPACT_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/impact`;
export const PRACTICE_IMPACT_PATIENTS_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/impact/appointments`;
export const PATIENTS_DIRECTORY_MANIFEST_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/patients-directory/manifest`;
export const PATIENTS_DIRECTORY_PATIENTS_URL = (practiceId) =>
  `/doctor/practices/${practiceId}/patients-directory/patients`;
export const DOCTOR_RESET_PASSWORD_URL = "/doctor/doctorResetPassword";
export const DOCTOR_GET_VISIT_DETAIL_URL = "/record/getVisitTreatment";
export const DOCTOR_GET_ALL_PATIENT_VISITS_URL = "/record/getAllVisit";
export const DOCTOR_GENERATE_AI_REPORT_URL = "/record/createGptSummary";
export const DOCTOR_FORGOT_PASSWORD_URL = "/doctor/doctorForgetPassword";
export const DOCTOR_CONFIRM_SUMMARY_URL = "/record/createPatientSummary";
export const DOCTOR_SEND_NOTIFICATION_URL = "/record/sendPatientNotification";
export const DOCTOR_ADD_VISIT_RECORD_URL = "/record/createVisitTreatment";
export const PATIENT_GET_VISIT_DETAIL_URL = "/record/getPatientTreatment";
export const DOCTOR_UPDATE_VISIT_RECORD_URL = "/record/updateVisitTreatment";
export const DOCTOR_DELETE_TREATMENT_URL = "/record/deletePatientTreatment";
export const DOCTOR_GET_ALL_PATIENTS_URL = "/patient/patientAssignToDoctor";
export const DOCTOR_VERIFY_REPORT_OTP_URL = "/record/verifyEmailProtectedOtp";
export const DOCTOR_DELETE_TREATMENT_ACTIVITY_URL =
  "/record/deletePatientTreatmentActivity";
export const DOCTOR_GET_ALL_TREATMENT_CODES_URL =
  "/doctor/getAllTreatmentCodes";
export const DOCTOR_ADD_TREATMENT_ACTIVITY_URL =
  "/record/createTreatmentActivity";
export const DOCTOR_GET_TREATMENT_ACTIVITIES_URL =
  "/record/getTreatmentActivity";

// treatment plan (txPlan) api endpoints
export const DOCTOR_TXPLAN_LIST_URL = "/doctor/txPlan/list";
export const DOCTOR_TRANSACTIONS_LIST_URL = "/doctor/transactions/list";
export const DOCTOR_PMS_NOTES_URL = "/doctor/pms-notes";
export const DOCTOR_TXPLAN_SUGGEST_URL = "/doctor/txPlan/suggest";
export const DOCTOR_TXPLAN_CREATE_URL = "/doctor/txPlan";
export const DOCTOR_TXPLAN_GET_ONE_URL = "/doctor/txPlan";
export const DOCTOR_TXPLAN_UPDATE_URL = "/doctor/txPlan";
export const DOCTOR_TXPLAN_DELETE_URL = "/doctor/txPlan";
export const DOCTOR_TXPLAN_GENERATE_SUMMARIES_URL = "/doctor/txPlan";
export const DOCTOR_TXPLAN_UPDATE_SUMMARIES_URL = "/doctor/txPlan";

// pms api endpoints
export const DOCTOR_SEARCH_PMS_PATIENTS_URL = "/pms/searchPatients";
export const DOCTOR_PMS_PENDING_SUMMARY_URL = "/pms/pending-summary";
export const DOCTOR_PMS_IMPORT_PATIENT_URL = "/pms/import-patient";
export const DOCTOR_PMS_SYNC_TREATMENTS_URL = "/pms/sync-treatments";

// appointments api endpoints
export const GET_PATIENT_APPOINTMENTS_URL = "/appointments/getPatientAppointments";
export const GET_APPOINTMENT_REQUESTS_URL = "/appointments/requests";
export const ADD_APPOINTMENT_REQUEST_CALLBACK_LOG_URL = "/appointments/requests";

// patient api endpoints
export const PATIENT_IDENTITY_VERIFICATION_URL =
  "/record/emailVerificationBeforeOtp";

// export const SIGNUP_URL = "/auth/signup";
// export const GET_USER_URL = "/user/getUser";
// export const VERIFY_OTP_URL = "/auth/verifyOtp";
// export const RESEND_OTP_URL = "/auth/resendOtp";
// export const EDIT_PROFILE_URL = "/user/updateUser";
// export const CANCEL_ORDER_URL = "/order/cancelOrder";
// export const GET_NDC_DETAIL_URL = "/ndc/getNdcDetail";
export const DELETE_ACCOUNT_URL = "/user/deleteAccount";
export const GET_ALL_VISIT_TREATMENT_IMAGES_URL = "/record/getVisitTreatmentImage";
// export const RESET_PASSWORD_URL = "/auth/resetPassword";
// export const ADMIN_GET_USER_PROFILE_URL = "/user/:userId";
// export const CHANGE_PASSWORD_URL = "/user/changePassword";
// export const FORGOT_PASSWORD_URL = "/auth/forgotPassword";
// export const ADMIN_GET_ALL_USERS_URL = "/user/getAllUsers";
// export const BUYER_CREATE_ORDER_URL = "/order/createOrder";
// export const GET_BUYER_ORDERS_URL = "/order/getBuyerOrders";
// export const BUYER_ADD_NDC_URL = "wishlist/addBuyerWishlist";
// export const BUYER_GET_WISHLIST_URL = "/wishlist/getWishlist";
// export const GET_SELLER_ORDERS_URL = "/order/getSellerOrders";
// export const ADMIN_GET_ALL_ORDERS_URL = "/order/getallOrders";
// export const SELLER_ADD_NDC_URL = "wishlist/addSellerWishlist";
// export const SELLER_GET_WISHLIST_URL = "/wishlist/getWishlist";
// export const ADD_SHIPMNET_DETAIL_URL = "/fedex/addFedExDetail";
// export const GET_PAYMENT_INTENT_URL = "/payment/paymentIntents";
// export const SELLER_CHANGE_ORDER_STATUS = "/order/changeOrderStatus";
// export const ADMIN_CHANGE_USER_STATUS_URL = "/user/changeUserStatus";
// export const ADD_PHARMACY_DETAIL_URL = "/pharmacy/addPharmacyDetails";
// export const WISHLIST_MARK_AS_COMPLETE_URL = "/wishlist/markAsComplete";
// export const ADMIN_GET_WISHLIST_MATCHING_URL = "/wishlist/matchWishlist";
// export const BUYER_GET_POTENTIAL_BUYS_URL = "/wishlist/showPotentialBuys";
// export const ADMIN_CHANGE_USER_COMMISSION_URL = "/user/updateUserCommision";
// export const GET_USER_NOTIFICATIONS_URL = "/notifications/getNotifications";
// export const ADMIN_SEND_MATCHED_TO_BUYER_URL = "/wishlist/sendMatchedToBuyer";
// export const ADMIN_GET_COMMISSION_VALUE_URL = "/commission/getcommissionvalue";
// export const ADMIN_UPDATE_COMMISSION_VALUE_URL =
//   "/commission/updatecommissionvalue";
// export const ADMIN_GET_COMMISSION_RECORDS_URL =
//   "commission/getFilteredCommissionRecords";
// export const USER_NOTIFICATIONS_MARK_ASREAD_URL =
//   "/notifications/updateNotifications";
// export const GET_STRIPE_ONBOARDING_STATUS_URL =
//   "/integrationstripe/getstripestatus";
// export const CREATE_STRIPE_ACCOUNT_AND_LINK_URL =
//   "/integrationstripe/createStripeAccount";

export const svgPaths = [
  {
    type: "path",
    d: "M48.2595 285.308C44.0245 292.67 23.2018 267.958 23.2018 260.932C16.5182 259.967 11.6876 245.108 12.9228 237.769C7.67299 233.639 1.60832 217.408 1.60832 217.408L0.804157 219.014L0 223.867L6.90099 267.329C30.5581 357.712 120.222 340.449 127.862 342.456C135.501 344.464 128.264 306.137 128.264 306.137C96.0148 307.35 68.2 299.538 48.2816 285.33L48.2595 285.308Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M49.1889 295.165C50.9536 297.676 53.2478 299.57 56.4022 300.033C58.7405 300.363 61.167 300.143 63.5053 300.606C67.8509 301.443 70.7407 305.077 74.976 306.112C75.2408 306.178 75.3069 306.398 75.2626 306.619C78.241 307.015 81.329 306.398 84.2632 307.522C87.4832 308.755 90.1083 311.398 93.5054 312.191C97.6309 313.183 100.984 311.046 104.998 311.134C108.704 311.222 111.572 313.711 115.123 314.482C119.249 315.363 123.241 313.711 127.411 314.261C127.763 314.306 128.116 314.372 128.469 314.416V306.861C96.219 308.05 68.4024 300.385 48.483 286.443C47.3581 288.359 45.0639 288.051 42.2844 286.443C43.608 287.786 44.9095 289.152 46.1007 290.606C47.2698 292.038 48.1301 293.689 49.1889 295.187V295.165Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M105.594 313.513C107.381 314.724 109.123 315.958 111.307 316.42C112.123 316.596 112.918 316.662 113.711 316.64C113.182 316.486 112.675 316.288 112.167 316.045C110.535 315.252 109.277 313.645 107.712 312.676C106.167 311.684 105.064 311.883 103.917 312.632C104.468 312.83 105.042 313.138 105.594 313.534V313.513Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M94.4761 314.284C91.3213 313.645 89.9762 311.09 87.4171 309.482C85.9834 308.579 83.4686 307.896 82.3215 309.614C82.4318 309.46 82.3657 309.328 82.1887 309.438C82.1452 309.438 82.1227 309.482 82.0784 309.504C82.0124 309.548 81.7258 309.878 81.8803 309.966C82.4318 310.231 83.0492 310.142 83.6449 310.253C85.0126 310.495 86.5348 311.684 87.5716 312.543C89.6888 314.284 91.3438 315.143 94.1452 314.922C94.3215 314.922 94.7184 314.372 94.4536 314.327L94.4761 314.284Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M73.1671 307.896C71.4242 307.323 70.1668 306.398 68.7109 305.319C67.8947 304.702 67.0785 303.733 66.1079 303.491C65.9756 303.446 65.8212 303.645 65.755 303.755C65.2035 304.702 66.4829 306.023 67.0786 306.64C68.6448 308.27 70.7403 308.601 72.9242 308.381C73.0568 308.381 73.4094 307.962 73.1889 307.896H73.1671Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M54.8355 299.789C51.1297 298.578 48.3502 295.714 46.8281 292.146C46.7619 291.97 46.4531 292.345 46.4531 292.454C46.6737 294.437 47.3796 296.287 48.5707 297.917C50.0046 299.877 51.9238 300.56 54.3062 300.67C54.5929 300.67 55.2547 299.921 54.8576 299.789H54.8355Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M33.9457 284.109C34.078 284.263 34.2103 284.395 34.3427 284.549C35.4457 285.76 37.0119 287.522 38.7104 287.765C39.1737 287.831 39.7913 287.016 39.6589 286.597C39.4163 285.849 38.9751 285.562 38.3354 285.122C37.5413 284.549 36.7913 283.91 36.0413 283.272C35.4016 282.743 34.7839 282.192 34.1442 281.664C33.4603 281.069 32.4677 280.474 31.9603 279.703C31.9162 279.637 31.8721 279.615 31.8059 279.637C32.1368 281.311 32.8869 282.809 33.9236 284.152L33.9457 284.109Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M205.654 286.42C209.89 293.645 230.713 269.394 230.713 262.5C237.397 261.553 242.096 244.416 240.86 237.192C247.809 230.1 252.908 210.984 252.908 210.984L253.712 215.802L250.258 263.602C229.588 354.902 129.872 341.252 127.862 342.456C125.851 343.661 125.668 306.838 125.668 306.838C157.918 308.028 185.735 300.362 205.654 286.42Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M141.815 314.217C144.528 312.939 147.021 310.737 150.198 311.111C152.359 311.353 154.433 312.08 156.617 312.036C159.33 311.97 161.734 311.287 164.117 310.031C164.249 309.965 164.404 309.965 164.514 310.031C165.109 309.591 165.683 309.129 166.278 308.776C167.58 308.027 169.036 307.609 170.536 307.697C172.631 307.807 174.97 308.446 177.044 307.829C179.272 307.168 181.058 305.803 182.845 304.371C185.625 302.146 188.382 300.428 191.889 299.592C193.323 299.261 194.691 298.953 195.992 298.512C195.64 298.336 195.706 297.697 196.191 297.697C197.25 297.697 198.176 297.499 199.014 297.169C199.985 296.574 200.867 295.825 201.684 294.834C201.904 294.57 202.191 294.702 202.324 294.922C203.36 293.975 204.375 292.918 205.522 291.993C208.698 289.437 212.492 287.742 215.691 285.142C219.154 282.345 222.882 279.284 225.221 275.451C227.272 272.103 228.618 268.315 230.934 265.121C233.073 262.17 235.787 259.681 237.618 256.487C239.691 252.853 240.463 248.954 241.059 244.857C241.346 242.897 241.61 240.915 242.206 239.021C242.89 236.884 244.015 234.99 244.787 232.919C244.941 232.501 245.074 232.104 245.184 231.686C244.103 233.426 242.713 235.298 240.838 237.214C242.073 244.439 237.375 261.575 230.691 262.522C230.691 269.416 209.867 293.645 205.632 286.442C185.735 300.407 157.918 308.049 125.646 306.86V314.151C126.219 314.151 126.793 314.194 127.388 314.26C132.263 314.921 137.072 316.441 141.793 314.217H141.815Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M148.52 313.513C146.734 314.724 145.013 315.958 142.807 316.42C141.991 316.596 141.197 316.662 140.403 316.64C140.932 316.486 141.439 316.288 141.947 316.045C143.579 315.252 144.836 313.645 146.403 312.676C147.947 311.684 149.05 311.883 150.197 312.632C149.646 312.83 149.072 313.138 148.52 313.534V313.513Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M180.948 307.896C182.69 307.323 183.948 306.398 185.425 305.319C186.241 304.702 187.057 303.733 188.028 303.491C188.16 303.446 188.315 303.645 188.381 303.755C188.933 304.702 187.653 306.023 187.057 306.64C185.492 308.27 183.396 308.601 181.212 308.381C181.08 308.381 180.749 307.962 180.948 307.896Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M199.301 299.789C203.007 298.578 205.786 295.714 207.308 292.146C207.374 291.97 207.683 292.345 207.683 292.454C207.463 294.437 206.757 296.287 205.565 297.917C204.132 299.877 202.212 300.56 199.83 300.67C199.543 300.67 198.881 299.921 199.278 299.789H199.301Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M221.049 284.163C220.917 284.317 220.785 284.449 220.652 284.604C219.55 285.815 217.983 287.577 216.285 287.819C215.822 287.885 215.204 287.071 215.336 286.652C215.601 285.903 216.02 285.617 216.66 285.176C217.454 284.604 218.182 283.965 218.954 283.326C219.594 282.797 220.211 282.247 220.851 281.718C221.535 281.124 222.527 280.529 223.035 279.758C223.079 279.692 223.123 279.67 223.19 279.692C222.858 281.366 222.086 282.863 221.072 284.207L221.049 284.163Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M233.493 263.117C234.154 262.258 235.015 261.641 235.787 260.893C236.846 259.857 237.486 258.668 238.302 257.457C239.669 255.452 240.198 252.875 241.191 250.695C241.279 250.518 241.61 250.915 241.566 251.069C240.155 255.981 238.809 261.135 234.044 263.844C233.779 263.998 233.294 263.381 233.47 263.139L233.493 263.117Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M237.63 268.776C231.938 277.256 227.978 287.52 220.235 294.172C212.051 301.22 203.448 307.938 193.83 313.004C184.124 318.114 173.757 321.352 163.058 323.577C152.337 325.779 141.462 327.299 130.52 327.849C108.682 328.951 86.1597 326.528 66.0418 317.608C56.049 313.181 46.5195 307.255 38.7106 299.568C31.2766 292.256 25.3648 283.599 20.8868 274.216C12.7911 257.256 8.04158 229.852 1.60827 217.407L0.804112 219.013L0 224.267L7.09988 268.776C30.9602 349.682 100.52 342.455 128.264 342.455C156.007 342.455 250.496 344.864 252.908 235.262V212.779C249.754 220.466 250.127 232.245 245.671 238.875L237.63 268.776Z",
    fill: "url(#paint0_radial_2002_6979)",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M161.363 313.353C163.106 312.78 164.363 311.855 165.841 310.776C166.657 310.159 167.473 309.19 168.444 308.948C168.576 308.903 168.73 309.102 168.796 309.212C169.349 310.159 168.069 311.481 167.473 312.097C165.907 313.727 163.811 314.058 161.628 313.838C161.495 313.838 161.164 313.419 161.363 313.353Z",
    fill: "#FEC5CE",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M223.809 190.347C221.116 193.021 218.961 199.038 220.039 208.398C221.116 217.089 231.889 238.482 242.124 233.802C250.204 230.459 254.514 219.094 252.36 205.055C250.743 191.016 248.588 189.01 244.279 187.673C240.508 186.336 238.892 189.01 235.66 189.01C232.967 189.01 228.657 185.667 223.809 190.347Z",
    fill: "#FAF9F5",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M223.81 190.347C221.116 193.021 218.962 199.038 220.039 208.398C221.116 217.089 231.89 238.482 242.124 233.802C250.204 230.459 254.515 219.094 252.36 205.055C250.743 191.016 248.588 189.01 244.279 187.673C240.508 186.336 238.892 189.01 235.66 189.01C232.967 189.01 228.658 185.667 223.81 190.347Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.896 186.337C247.512 188.342 247.512 193.022 246.435 196.364C245.357 199.707 248.589 204.387 250.205 211.072C251.821 217.757 243.741 223.106 233.506 223.106C223.271 223.774 218.423 214.415 217.884 205.723C217.346 196.364 221.655 187.674 228.119 187.005C235.122 184.999 243.741 184.33 245.896 186.337Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.895 186.337C247.511 188.342 247.511 193.022 246.434 196.364C245.356 199.038 249.127 204.387 250.204 211.072C251.82 217.757 243.74 223.106 234.044 223.106C223.81 223.774 218.961 214.415 218.422 205.723C217.883 196.364 222.194 187.674 228.658 187.005C235.122 184.999 243.202 184.33 245.895 186.337Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.355 186.337C246.971 188.343 246.971 193.022 245.894 196.365C244.817 199.039 248.587 204.388 249.665 211.073C251.282 217.759 243.201 222.438 233.505 223.107C223.809 223.775 218.422 214.416 217.883 205.725C217.345 196.365 221.654 187.675 228.118 187.006C234.582 185.669 243.201 184.332 245.355 186.337Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.355 187.006C246.971 189.011 246.971 193.691 245.894 197.033C244.817 199.707 248.587 205.056 249.665 211.741C251.282 218.426 243.201 223.106 233.505 223.775C223.809 224.443 218.422 215.084 217.883 206.393C217.345 197.033 221.654 188.343 228.118 187.674C234.582 185.668 243.201 184.331 245.355 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.355 187.006C246.971 189.011 246.971 193.691 245.894 197.033C244.817 199.707 248.587 205.056 249.665 211.741C251.282 218.426 243.201 223.106 233.505 223.775C223.809 224.443 218.422 215.084 217.883 206.393C217.345 197.033 221.654 188.343 228.118 187.674C234.582 185.668 243.201 184.331 245.355 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.355 187.006C246.971 189.011 246.971 193.691 245.894 197.033C244.817 199.707 248.587 205.056 249.665 211.741C251.282 218.426 243.201 223.106 233.505 223.775C223.809 224.443 218.422 215.084 217.883 206.393C217.345 197.033 221.654 188.343 228.118 187.674C234.582 185.668 243.201 184.331 245.355 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M245.355 187.004C246.971 189.01 246.433 193.689 245.894 196.364C244.817 199.038 248.049 203.718 249.665 210.403C251.282 217.088 243.201 221.768 233.505 222.437C223.809 223.105 218.422 214.414 217.883 205.055C217.345 196.364 221.654 187.672 228.118 186.335C234.582 185.667 243.201 184.33 245.355 187.004Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.818 187.006C246.434 189.011 245.895 193.691 245.356 196.365C244.279 199.039 247.511 203.719 249.127 210.404C250.743 217.089 242.663 221.769 232.966 222.438C223.27 222.438 217.883 214.415 217.345 205.056C216.806 196.365 221.115 187.674 227.579 186.336C234.582 185.668 242.663 184.999 244.818 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.818 187.006C246.434 189.011 245.895 193.691 245.356 196.365C244.279 199.039 247.511 203.719 249.127 210.404C250.743 217.089 242.663 221.769 232.966 222.438C223.27 222.438 217.883 214.416 217.345 205.056C216.806 196.365 221.115 187.674 227.579 186.337C234.582 186.337 242.663 185 244.818 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.818 187.006C246.434 189.011 245.895 193.691 245.356 196.365C244.279 199.039 247.511 203.719 249.127 210.404C250.743 217.089 242.663 221.769 232.966 222.438C223.27 222.438 217.883 214.416 217.883 205.056C217.345 196.365 221.654 187.674 228.118 186.337C234.043 186.337 242.663 185 244.818 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.818 187.674C246.434 189.679 245.895 194.359 245.356 197.033C244.279 199.707 247.511 204.387 249.127 211.072C250.743 217.757 242.663 222.437 232.966 223.106C223.27 223.106 217.883 215.084 217.883 205.724C217.345 197.033 221.654 188.342 228.118 187.005C234.043 186.337 242.663 185 244.818 187.674Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.818 187.673C246.434 189.679 245.895 194.358 245.356 197.033C244.279 199.707 247.511 204.387 249.127 211.072C250.743 217.758 242.663 222.438 232.966 222.438C223.27 222.438 217.883 214.415 217.883 205.055C217.345 196.365 221.654 187.673 228.118 186.336C234.043 186.336 242.663 184.999 244.818 187.673Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.278 187.674C245.894 189.679 245.355 194.359 244.817 197.033C243.739 199.707 246.971 204.387 248.587 211.072C250.203 217.757 242.123 222.437 232.966 222.437C223.27 222.437 218.422 214.415 217.883 205.055C217.345 196.364 221.654 187.674 228.118 187.005C234.043 186.337 242.123 185 244.278 187.674Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.278 187.672C245.894 189.678 245.355 194.357 244.817 197.032C243.739 199.706 246.971 204.386 248.588 211.071C250.204 217.756 242.662 222.436 232.966 222.436C223.27 222.436 218.422 214.413 217.883 205.723C217.345 197.032 221.654 188.34 228.118 187.672C234.043 186.335 242.123 185.667 244.278 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.278 187.672C245.894 189.678 245.355 194.357 244.817 197.032C243.739 199.706 246.971 204.386 248.588 211.071C250.204 217.756 242.662 222.436 232.966 222.436C223.27 222.436 218.422 214.413 217.883 205.723C217.345 197.032 221.654 188.34 228.118 187.672C234.043 186.335 242.123 185.667 244.278 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.278 187.672C245.894 189.679 245.356 194.358 244.817 197.032C243.74 199.706 246.972 204.386 248.588 211.072C250.204 217.757 242.662 222.436 232.966 222.436C223.27 222.436 218.422 214.414 217.883 205.723C217.345 197.032 221.654 188.341 227.579 187.672C234.043 187.004 242.124 185.667 244.278 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M244.278 187.672C245.894 189.679 245.356 194.358 244.817 197.032C243.74 199.706 246.972 204.386 248.588 211.072C250.204 217.757 242.662 222.436 232.966 222.436C223.27 222.436 218.422 214.414 217.883 205.723C217.345 197.032 221.654 188.341 227.579 187.672C234.043 187.004 242.124 185.667 244.278 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M243.741 188.343C245.357 190.348 244.818 195.028 244.28 197.702C243.202 200.377 246.434 205.056 248.05 211.741C249.666 218.427 242.125 223.107 232.428 223.107C222.732 223.107 217.884 215.084 217.345 206.393C216.807 197.702 221.116 189.011 227.041 188.343C233.505 187.006 242.125 185.668 243.741 188.343Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M243.741 188.343C245.357 190.348 244.818 195.028 244.28 197.702C243.202 200.377 246.434 205.056 248.05 211.741C249.666 218.427 242.125 223.107 232.428 223.107C222.732 223.107 217.884 215.084 217.345 206.393C216.807 197.702 221.116 189.011 227.041 188.343C233.505 187.006 241.586 185.668 243.741 188.343Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M243.741 188.343C245.357 190.348 244.818 195.028 244.28 197.702C243.202 200.377 246.434 205.056 248.05 211.741C249.666 218.427 242.125 223.107 232.428 223.107C222.732 223.107 217.884 215.084 217.345 206.393C216.807 197.702 221.116 189.68 227.041 188.343C233.505 187.006 241.586 185.668 243.741 188.343Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M243.741 188.342C245.357 190.347 244.818 195.027 244.28 197.701C243.202 200.376 246.434 205.055 248.05 211.74C249.666 218.426 242.125 222.437 232.428 223.106C223.271 223.106 217.884 215.083 217.884 206.393C217.345 197.701 221.655 189.679 227.58 188.342C233.506 187.005 241.586 186.336 243.741 188.342Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M226.544 195.026C227.348 195.006 228.132 195.121 228.915 195.006C229.804 194.873 230.714 194.531 231.561 194.284C232.048 194.131 232.534 194.017 233 193.922C232.132 193.313 231.307 192.666 230.397 192.077C230.079 191.867 229.74 191.03 230.397 191.41C231.18 191.867 231.963 192.077 232.788 192.4C233.551 192.704 234.164 193.123 234.884 193.485C235.074 193.579 235.265 193.675 235.434 193.751C236.471 192.343 239.414 191.22 241.086 191.886C241.256 191.962 241.869 192.533 241.573 192.704C240.091 193.542 238.059 194.873 237.318 196.319C237.086 196.757 236.641 198.508 236.916 198.926C237.466 199.782 237.762 200.505 237.847 201.514C237.89 201.989 237.213 201.628 237.064 201.476C236.852 201.286 236.662 201.076 236.556 200.81C236.514 200.676 236.471 200.524 236.556 200.429C236.302 199.268 235.413 198.412 235.18 197.213C235.053 196.548 234.927 195.957 234.948 195.368C233.826 195.349 232.683 195.768 231.561 195.996C230.1 196.319 228.851 196.491 227.348 196.339C226.903 196.3 225.972 195.026 226.565 195.006L226.544 195.026Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_17",
    id: "teeth_17",
  },
  {
    type: "path",
    d: "M30.3074 190.347C33.0008 193.021 35.1555 199.038 34.0782 208.398C33.0008 217.089 22.2273 238.482 11.9923 233.802C3.91214 230.459 -0.397305 219.094 1.75741 205.055C3.37345 191.016 5.5282 189.01 9.83764 187.673C13.6083 186.336 15.2244 189.01 18.4565 189.01C21.1499 189.01 25.4593 185.667 30.3074 190.347Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M30.3074 190.347C33.0008 193.021 35.1555 199.038 34.0782 208.398C33.0008 217.089 22.2273 238.482 11.9923 233.802C3.91214 230.459 -0.397305 219.094 1.75741 205.055C3.37345 191.016 5.5282 189.01 9.83764 187.673C13.6083 186.336 15.2244 189.01 18.4565 189.01C21.1499 189.01 25.4593 185.667 30.3074 190.347Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.22159 186.336C6.60557 188.342 6.60557 193.022 7.68292 196.364C8.76026 199.707 5.52823 204.386 3.91216 211.072C2.29612 217.757 10.3763 223.106 20.6112 223.106C30.8461 223.774 35.6942 214.415 36.233 205.723C36.7716 196.364 32.4622 187.673 25.998 187.005C18.9951 184.999 10.3763 184.33 8.22159 186.336Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.22196 186.336C6.60588 188.342 6.60588 193.022 7.68329 196.364C8.76063 199.038 4.98987 204.386 3.91251 211.072C2.29647 217.757 10.3766 223.106 20.0729 223.106C30.3078 223.774 35.1559 214.415 35.6946 205.723C36.2333 196.364 31.9238 187.673 25.4597 187.005C18.9955 184.999 10.9153 184.33 8.22196 186.336Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.76123 186.337C7.14522 188.343 7.14522 193.022 8.22256 196.365C9.2999 199.039 5.52921 204.388 4.45182 211.073C2.83577 217.759 10.916 222.438 20.6122 223.107C30.3084 223.775 35.6953 214.416 36.2339 205.725C36.7726 196.365 32.4632 187.675 25.999 187.006C19.5349 185.669 10.916 184.332 8.76123 186.337Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.76123 187.006C7.14522 189.011 7.14522 193.691 8.22256 197.033C9.2999 199.707 5.52921 205.056 4.45182 211.741C2.83577 218.426 10.916 223.106 20.6122 223.775C30.3084 224.443 35.6953 215.084 36.2339 206.393C36.7726 197.033 32.4632 188.343 25.999 187.674C19.5349 185.668 10.916 184.331 8.76123 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.76123 187.006C7.14522 189.011 7.14522 193.691 8.22256 197.033C9.2999 199.707 5.52921 205.056 4.45182 211.741C2.83577 218.426 10.916 223.106 20.6122 223.775C30.3084 224.443 35.6953 215.084 36.2339 206.393C36.7726 197.033 32.4632 188.343 25.999 187.674C19.5349 185.668 10.916 184.331 8.76123 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.76123 187.006C7.14522 189.011 7.14522 193.691 8.22256 197.033C9.2999 199.707 5.52921 205.056 4.45182 211.741C2.83577 218.426 10.916 223.106 20.6122 223.775C30.3084 224.443 35.6953 215.084 36.2339 206.393C36.7726 197.033 32.4632 188.343 25.999 187.674C19.5349 185.668 10.916 184.331 8.76123 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M8.76123 187.004C7.14522 189.01 7.68389 193.689 8.22256 196.364C9.2999 199.038 6.06788 203.718 4.45182 210.403C2.83577 217.088 10.916 221.768 20.6122 222.437C30.3084 223.105 35.6953 214.414 36.2339 205.055C36.7726 196.364 32.4632 187.672 25.999 186.335C19.5349 185.667 10.916 184.33 8.76123 187.004Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.29958 187.006C7.68357 189.011 8.22224 193.691 8.76091 196.365C9.83826 199.039 6.60616 203.719 4.99015 210.404C3.37411 217.089 11.4543 221.769 21.1506 222.438C30.8468 222.438 36.2336 214.415 36.7722 205.056C37.3109 196.365 33.0015 187.674 26.5373 186.336C19.5345 185.668 11.4543 184.999 9.29958 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.29958 187.006C7.68357 189.011 8.22224 193.691 8.76091 196.365C9.83826 199.039 6.60616 203.719 4.99015 210.404C3.37411 217.089 11.4543 221.769 21.1506 222.438C30.8468 222.438 36.2336 214.416 36.7722 205.056C37.3109 196.365 33.0015 187.674 26.5373 186.337C19.5345 186.337 11.4543 185 9.29958 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.29958 187.006C7.68357 189.011 8.22224 193.691 8.76091 196.365C9.83826 199.039 6.60616 203.719 4.99015 210.404C3.37411 217.089 11.4543 221.769 21.1506 222.438C30.8468 222.438 36.2336 214.416 36.2336 205.056C36.7722 196.365 32.4628 187.674 25.9987 186.337C20.0731 186.337 11.4543 185 9.29958 187.006Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.29946 187.674C7.68345 189.679 8.22212 194.359 8.76079 197.033C9.83813 199.707 6.60604 204.387 4.99003 211.072C3.37398 217.757 11.4541 222.437 21.1504 223.106C30.8467 223.106 36.2334 215.084 36.2334 205.724C36.7721 197.033 32.4627 188.342 25.9985 187.005C20.073 186.337 11.4542 185 9.29946 187.674Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.29958 187.673C7.68357 189.679 8.22224 194.358 8.76091 197.033C9.83826 199.707 6.60616 204.387 4.99015 211.072C3.37411 217.758 11.4543 222.438 21.1506 222.438C30.8468 222.438 36.2336 214.415 36.2336 205.055C36.7722 196.365 32.4628 187.673 25.9987 186.336C20.0731 186.336 11.4543 184.999 9.29958 187.673Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.8385 187.674C8.22249 189.679 8.76116 194.359 9.29983 197.033C10.3772 199.707 7.14515 204.387 5.52906 211.072C3.91305 217.757 11.9933 222.437 21.1508 222.437C30.847 222.437 35.6951 214.415 36.2338 205.055C36.7725 196.364 32.463 187.674 25.9989 187.005C20.0735 186.337 11.9933 185 9.8385 187.674Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.83846 187.672C8.22238 189.678 8.76105 194.357 9.29979 197.032C10.3771 199.706 7.14504 204.386 5.52902 211.071C3.91296 217.756 11.4545 222.436 21.1507 222.436C30.8469 222.436 35.6951 214.413 36.2338 205.723C36.7724 197.032 32.463 188.34 25.9988 187.672C20.0733 186.335 11.9931 185.667 9.83846 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.83846 187.672C8.22238 189.678 8.76105 194.357 9.29979 197.032C10.3771 199.706 7.14504 204.386 5.52902 211.071C3.91296 217.756 11.4545 222.436 21.1507 222.436C30.8469 222.436 35.6951 214.413 36.2338 205.723C36.7724 197.032 32.463 188.34 25.9988 187.672C20.0733 186.335 11.9931 185.667 9.83846 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.83846 187.672C8.22238 189.679 8.76105 194.358 9.29979 197.032C10.3771 199.706 7.14504 204.386 5.52902 211.072C3.91296 217.757 11.4545 222.436 21.1507 222.436C30.8469 222.436 35.6951 214.414 36.2338 205.723C36.7724 197.032 32.463 188.341 26.5375 187.672C20.0733 187.004 11.9931 185.667 9.83846 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M9.83846 187.672C8.22238 189.679 8.76105 194.358 9.29979 197.032C10.3771 199.706 7.14504 204.386 5.52902 211.072C3.91296 217.757 11.4545 222.436 21.1507 222.436C30.8469 222.436 35.6951 214.414 36.2338 205.723C36.7724 197.032 32.463 188.341 26.5375 187.672C20.0733 187.004 11.9931 185.667 9.83846 187.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M10.3763 188.343C8.76022 190.348 9.29889 195.028 9.83756 197.702C10.915 200.377 7.68288 205.056 6.06687 211.741C4.4508 218.427 11.9923 223.107 21.6885 223.107C31.3847 223.107 36.2329 215.084 36.7716 206.393C37.3103 197.702 33.0008 189.011 27.0753 188.343C20.6112 187.006 11.9923 185.668 10.3763 188.343Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M10.3763 188.343C8.76022 190.348 9.29889 195.028 9.83756 197.702C10.915 200.377 7.68288 205.056 6.06687 211.741C4.4508 218.427 11.9923 223.107 21.6885 223.107C31.3847 223.107 36.2329 215.084 36.7716 206.393C37.3103 197.702 33.0008 189.011 27.0753 188.343C20.6112 187.006 12.531 185.668 10.3763 188.343Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M10.3763 188.343C8.76022 190.348 9.29889 195.028 9.83756 197.702C10.915 200.377 7.68288 205.056 6.06687 211.741C4.4508 218.427 11.9923 223.107 21.6885 223.107C31.3847 223.107 36.2329 215.084 36.7716 206.393C37.3103 197.702 33.0008 189.68 27.0753 188.343C20.6112 187.006 12.531 185.668 10.3763 188.343Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M10.3763 188.342C8.76022 190.347 9.29889 195.027 9.83756 197.701C10.915 200.376 7.68288 205.055 6.06687 211.74C4.4508 218.426 11.9923 222.437 21.6885 223.106C30.8461 223.106 36.2329 215.083 36.2329 206.393C36.7716 197.701 32.4622 189.679 26.5366 188.342C20.6112 187.005 12.531 186.336 10.3763 188.342Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M27.573 195.026C26.7686 195.006 25.9855 195.121 25.2022 195.006C24.3132 194.873 23.403 194.531 22.5563 194.284C22.0695 194.131 21.5825 194.017 21.1169 193.922C21.9848 193.313 22.8103 192.666 23.7205 192.077C24.038 191.867 24.3767 191.03 23.7205 191.41C22.9373 191.867 22.1541 192.077 21.3285 192.4C20.5665 192.704 19.9527 193.123 19.233 193.485C19.0425 193.579 18.8519 193.675 18.6826 193.751C17.6454 192.343 14.7031 191.221 13.0308 191.886C12.8615 191.962 12.2476 192.533 12.544 192.704C14.0257 193.542 16.0578 194.873 16.7987 196.319C17.0315 196.757 17.476 198.508 17.2009 198.926C16.6505 199.782 16.3541 200.505 16.2695 201.514C16.2271 201.989 16.9045 201.628 17.0527 201.476C17.2643 201.286 17.4549 201.076 17.5607 200.81C17.6031 200.676 17.6454 200.524 17.5607 200.429C17.8147 199.268 18.7037 198.412 18.9366 197.213C19.0636 196.548 19.1906 195.957 19.1695 195.368C20.2913 195.349 21.4344 195.768 22.5563 195.996C24.0168 196.319 25.2658 196.491 26.7686 196.339C27.2132 196.3 28.1445 195.026 27.5518 195.006L27.573 195.026Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_32",
    id: "teeth_32",
  },
  {
    type: "path",
    d: "M35.695 205.056C38.3884 207.061 41.0819 212.41 40.5432 221.77C40.0045 231.129 28.1536 251.853 17.9186 247.843C9.83839 244.5 5.52903 233.803 6.60637 219.764C8.22238 205.724 10.9158 203.05 14.1479 203.719C17.3799 204.387 20.612 205.056 23.3055 205.056C27.0761 205.056 31.3856 201.045 35.695 205.056Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M35.695 205.056C38.3884 207.061 41.0819 212.41 40.5432 221.77C40.0045 231.129 28.1536 251.853 17.9186 247.843C9.83839 244.5 5.52903 233.803 6.60637 219.764C8.22238 205.724 10.9158 203.05 14.1479 203.719C17.3799 204.387 20.612 205.056 23.3055 205.056C27.0761 205.056 31.3856 201.045 35.695 205.056Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6982 217.091C42.6982 217.091 41.6209 210.405 38.9274 207.062C36.2341 203.051 29.2312 201.045 24.3831 201.045C19.535 200.377 13.6096 201.045 13.0708 204.388C12.5321 207.731 15.2256 210.405 14.6869 215.085C14.1482 221.102 10.9161 231.13 10.9161 239.821C10.9161 248.511 38.3888 245.838 38.3888 245.838C38.3888 245.838 43.2369 227.118 42.6982 217.091Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6982 217.091C42.6982 217.091 41.6209 210.405 38.9274 207.062C36.2341 203.051 29.2312 201.045 24.3831 201.045C19.535 200.377 13.6096 201.045 13.0708 204.388C12.5321 207.731 15.2256 210.405 14.6869 215.085C14.1482 221.102 10.9161 230.461 10.9161 239.821C10.9161 248.511 38.3888 245.838 38.3888 245.838C38.3888 245.838 43.2369 227.118 42.6982 217.091Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6977 217.091C42.6977 217.091 41.6203 210.405 38.9269 207.062C36.2335 203.051 29.2307 201.045 24.3826 201.045C19.5345 200.377 13.6089 201.045 13.0703 204.388C12.5316 207.731 15.225 210.405 14.6863 215.085C14.1476 221.102 10.9156 230.461 10.3768 239.152C10.3768 247.843 37.3109 245.169 37.3109 245.169C37.3109 245.169 43.2363 226.45 42.6977 217.091Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6982 217.091C42.6982 217.091 41.6209 210.405 38.9274 207.062C36.2341 203.051 29.2312 201.045 24.3831 201.045C19.535 200.377 13.6096 201.045 13.0708 204.388C12.5321 207.731 15.7642 209.736 15.2256 215.085C14.6869 221.102 11.4548 229.792 10.9161 239.152C10.9161 247.843 37.8501 245.169 37.8501 245.169C37.8501 245.169 43.2369 226.45 42.6982 217.091Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 217.091C42.6974 217.091 41.62 211.074 38.9266 207.062C36.2333 203.051 29.2304 201.714 24.921 201.045C20.6115 200.377 14.1473 201.045 13.6087 204.388C13.07 207.731 16.3021 209.736 15.7634 215.085C15.2247 221.102 11.454 229.792 11.454 239.152C11.454 247.843 38.388 245.169 38.388 245.169C38.388 245.169 43.2361 226.45 42.6974 217.091Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 216.421C42.6974 216.421 41.62 210.404 38.9266 206.392C36.2333 202.382 29.2304 201.044 24.921 200.376C20.6115 199.707 14.1473 200.375 13.6087 203.719C13.07 207.061 16.3021 209.067 15.7634 214.415C15.2247 220.432 11.454 228.454 11.454 238.482C11.454 247.173 38.388 244.499 38.388 244.499C38.388 244.499 43.2361 226.448 42.6974 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 216.421C42.6974 216.421 41.62 210.404 38.9266 206.392C36.2333 202.382 29.2304 201.044 24.921 200.376C20.6115 199.707 14.1473 200.375 13.6087 203.719C13.07 207.061 16.3021 209.067 15.7634 214.415C15.2247 220.432 11.454 228.454 11.454 237.814C11.454 246.505 37.8493 243.831 37.8493 243.831C37.8493 243.831 43.2361 226.448 42.6974 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 216.421C42.6974 216.421 41.62 210.404 38.9266 206.392C36.2333 202.382 29.2304 201.044 24.921 200.376C20.6115 199.707 14.1473 200.375 13.6087 203.719C13.07 207.061 16.3021 208.398 15.7634 214.415C15.2247 220.432 11.454 227.785 11.454 237.814C11.454 246.505 37.8493 243.831 37.8493 243.831C37.8493 243.831 43.2361 225.78 42.6974 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 216.421C42.6974 216.421 41.62 210.404 38.9266 206.392C36.2333 202.382 29.2304 201.044 24.921 200.376C20.6115 199.707 14.1473 200.375 13.6087 203.719C13.07 207.061 16.3021 208.398 15.7634 214.415C15.2247 220.432 11.454 227.785 11.454 237.814C11.454 245.836 37.8493 243.831 37.8493 243.831C37.8493 243.831 43.2361 225.78 42.6974 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 216.421C42.6974 216.421 41.62 210.404 38.9266 206.392C36.2333 202.382 29.2304 201.044 24.921 200.376C20.6115 199.707 14.1473 200.375 13.6087 203.719C13.07 207.061 16.3021 208.398 15.7634 214.415C15.2247 219.763 11.454 227.117 11.454 237.814C11.454 245.836 37.8493 243.831 37.8493 243.831C37.8493 243.831 43.2361 225.78 42.6974 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6988 216.421C42.6988 216.421 41.6214 210.404 38.928 206.392C36.2346 202.382 29.7704 201.044 24.9223 200.376C20.6129 199.707 14.1488 200.375 13.61 203.719C13.0714 207.061 16.8421 208.398 16.3035 214.415C15.7648 219.763 11.994 227.117 11.994 237.145C11.994 245.168 37.8506 242.494 37.8506 242.494C37.8506 242.494 43.2374 225.78 42.6988 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6974 216.421C42.6974 216.421 41.6201 210.404 38.9266 206.392C36.2333 202.382 29.7691 201.044 24.921 200.376C20.6115 199.707 14.1473 200.375 13.6087 203.719C13.07 207.061 16.8408 207.729 16.3021 214.415C15.7634 219.763 11.454 226.449 11.9927 237.145C11.9927 245.168 37.8493 242.494 37.8493 242.494C37.8493 242.494 43.2361 225.78 42.6974 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.698 216.421C42.698 216.421 41.6206 210.404 38.9273 206.392C36.2338 202.382 29.7697 201.044 25.4603 200.376C21.1508 199.707 14.6867 200.375 14.148 203.719C13.6093 207.061 17.3801 207.729 16.8414 214.415C16.3027 219.763 11.9932 226.449 12.532 237.145C13.0706 245.168 38.3886 242.494 38.3886 242.494C38.3886 242.494 43.2367 225.78 42.698 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.698 216.421C42.698 216.421 41.6206 210.404 38.9273 206.392C36.2338 203.05 29.7697 201.044 25.4603 200.376C21.1508 199.707 14.6867 200.375 14.148 203.719C13.6093 207.061 17.3801 207.729 16.8414 214.415C16.3027 219.763 11.9932 225.78 12.532 237.145C13.0706 245.168 38.3886 242.494 38.3886 242.494C38.3886 242.494 43.2367 225.112 42.698 216.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.698 215.752C42.698 215.752 41.6206 209.735 38.9273 206.392C36.2338 203.05 29.7697 201.044 25.4603 200.376C21.1509 199.707 15.2253 200.375 14.148 203.719C13.6093 207.061 17.3801 207.061 16.8414 214.415C16.3027 219.763 11.9932 225.78 12.532 236.477C13.0706 244.499 37.8499 241.825 37.8499 241.825C37.8499 241.825 43.2367 225.112 42.698 215.752Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.698 215.752C42.698 215.752 41.6206 209.736 38.9273 206.393C36.2338 203.051 29.7697 201.044 25.4603 200.376C21.1509 199.708 15.2253 200.376 14.148 203.051C13.6093 205.724 17.3801 206.393 16.8414 213.747C16.3027 219.095 11.9932 224.444 12.532 235.808C13.0706 243.831 37.8499 241.157 37.8499 241.157C37.8499 241.157 43.2367 225.112 42.698 215.752Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.698 215.752C42.698 215.752 41.6206 209.736 38.9273 206.393C36.2338 203.051 29.7697 201.044 25.4603 200.376C21.1509 199.708 15.2253 200.376 14.148 203.051C13.6093 205.724 17.3801 206.393 16.8414 213.747C16.3027 219.095 11.9932 224.444 12.532 235.808C13.0706 243.831 37.8499 241.157 37.8499 241.157C37.8499 241.157 43.2367 225.112 42.698 215.752Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.698 215.752C42.698 215.752 41.6206 209.736 38.9273 206.393C36.2338 203.051 29.7697 201.044 25.4603 200.376C21.1509 199.708 15.2253 200.376 14.148 203.051C13.6093 205.724 17.3801 206.393 16.8414 213.747C16.3027 219.095 11.9932 223.775 12.532 235.808C13.0706 243.831 37.8499 241.157 37.8499 241.157C37.8499 241.157 43.2367 225.112 42.698 215.752Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6985 215.752C42.6985 215.752 41.6211 209.736 38.9277 206.393C36.2344 203.051 29.7702 201.044 25.4607 200.376C21.1513 199.708 15.2258 200.376 14.1485 203.051C13.6098 205.724 17.3805 205.724 17.3805 213.747C16.8419 219.095 11.9937 223.775 13.0711 235.14C13.6098 243.163 38.389 240.488 38.389 240.488C38.389 240.488 43.2372 224.444 42.6985 215.752Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6985 215.752C42.6985 215.752 41.6211 209.736 38.9277 206.393C36.2344 203.051 29.7702 201.044 25.4607 200.376C21.1513 199.708 15.2258 200.376 14.1485 203.051C13.6098 205.724 17.9193 205.724 17.3805 213.747C16.8419 219.095 11.9937 223.775 13.0711 235.14C13.6098 243.163 37.8504 240.488 37.8504 240.488C37.8504 240.488 43.2372 224.444 42.6985 215.752Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M42.6983 215.752C42.6983 215.752 41.621 209.736 38.9276 206.393C36.2342 203.051 29.77 201.044 25.9993 200.376C21.6899 199.708 15.7644 200.376 15.2257 203.051C14.687 205.724 18.9965 205.724 18.4578 213.747C17.9191 219.095 13.071 223.107 14.1484 235.14C14.687 243.163 38.9276 240.488 38.9276 240.488C38.9276 240.488 43.237 224.444 42.6983 215.752Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M33.2917 211.424C33.2917 211.424 33.1684 211.424 33.0913 211.424C33.0913 211.383 33.0605 211.383 33.0143 211.424C33.0143 211.424 32.9834 211.424 32.968 211.424C31.7811 211.487 30.7792 212.32 29.7156 213.049C28.3437 214.007 26.4786 212.674 25.2147 211.424C25.1684 211.341 25.1221 211.279 25.0759 211.195C24.1664 209.779 22.9795 208.925 21.731 208.196C21.2377 207.904 20.7291 207.759 20.2204 207.571C19.6346 207.341 18.9564 207.695 18.4169 207.383C18.2782 207.3 18.0007 207.738 18.1241 207.863C18.5865 208.362 19.2338 208.279 19.8042 208.487C20.9448 208.883 21.9622 209.717 22.9333 210.591C24.2744 211.82 26.6481 215.007 25.9391 217.527C25.8004 218.048 26.2011 217.736 26.309 217.507C26.8331 216.382 26.7406 215.091 26.3707 213.903C26.8331 214.299 27.311 214.611 27.7734 214.82C28.0817 214.944 28.4054 214.882 28.7137 214.736C28.39 215.361 28.1434 216.049 28.02 216.799C27.8813 217.674 28.652 216.861 28.7907 216.569C29.2686 215.507 29.5615 214.57 30.2705 213.757C31.1491 213.111 31.9353 212.445 33.0143 212.132C33.153 212.091 33.5383 211.404 33.2917 211.404V211.424Z",
    fill: "#C3C3BC",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M8.82873 237.023C8.82873 236.847 8.91696 236.736 9.02724 236.67C6.15961 230.635 5.62919 219.015 8.44378 210.584C9.17174 207.853 9.3001 206.857 11.6604 204.963C14.0729 203.759 13.6708 204.562 20.1041 205.364C20.1041 205.364 14.6314 203.054 12.8667 203.759C10.8813 204.552 8.56607 206.819 7.6396 208.978C6.73519 211.114 7.35189 215.738 6.03132 217.409C4.82504 219.818 3.13048 220.772 1.6084 218.614C2.49077 222.578 1.76082 220.446 3.21672 224.234C4.60644 227.89 6.93168 234.005 8.8949 237.441C8.8949 237.287 8.85078 237.155 8.85078 237L8.82873 237.023Z",
    fill: "#DEDED4",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M24.0856 204.351C25.3702 204.104 26.5866 203.965 27.8341 204.118C29.2373 204.283 30.5863 204.46 32.0454 204.24C33.033 204.087 34.008 203.853 34.9814 203.581C30.6762 204.226 26.3591 204.184 25.0654 203.193C24.3411 203.94 23.3021 204.376 22.1147 204.554C22.7616 204.532 23.4162 204.481 24.077 204.362L24.0856 204.351Z",
    fill: "#E9E7DD",
    opacity: 1.0,
    class: "teeth_31",
    id: "teeth_31",
  },
  {
    type: "path",
    d: "M218.735 205.056C216.041 207.061 213.348 212.41 213.887 221.77C214.425 231.129 226.277 251.853 236.512 247.843C244.592 244.5 248.901 233.803 247.824 219.764C246.208 205.724 243.514 203.05 240.282 203.719C237.05 204.387 233.818 205.056 231.125 205.056C227.354 205.056 223.044 201.045 218.735 205.056Z",
    fill: "#FAF9F5",
    opacity: 0.8,
    class: "teeth_18",
    id: "teeth_18",
  },
  {
    type: "path",
    d: "M242.783 236.756C242.783 236.58 242.696 236.47 242.585 236.403C245.453 230.369 245.983 218.748 243.169 210.317C242.441 207.586 242.312 206.591 239.952 204.696C237.539 203.492 237.941 203.893 231.508 204.696C231.508 204.696 236.981 202.788 238.746 203.492C240.731 204.285 243.047 206.553 243.973 208.711C244.877 210.848 244.261 215.471 245.581 217.142C246.787 219.551 249.286 221.576 250.808 219.417C249.926 223.382 250.656 221.249 249.2 225.038C247.81 228.694 244.681 233.739 242.717 237.175C242.717 237.02 242.762 236.888 242.762 236.734L242.783 236.756Z",
    fill: "#DEDED4",
    opacity: 1.0,
    class: "teeth_18",
    id: "teeth_18",
  },
  {
    type: "path",
    d: "M227.125 204.351C225.841 204.104 224.624 203.965 223.377 204.118C221.973 204.283 219.77 204.143 219.891 204.161C219.918 204.161 219.848 204.161 219.848 204.161C220.652 204.161 224.852 204.184 226.145 203.193C226.869 203.94 227.908 204.376 229.096 204.554C228.449 204.532 227.794 204.481 227.134 204.362L227.125 204.351Z",
    fill: "#E9E7DD",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M218.723 210.811C218.723 210.811 218.846 210.811 218.923 210.811C218.923 210.77 218.954 210.77 219 210.811C219 210.811 219.031 210.811 219.046 210.811C220.233 210.873 221.235 211.707 222.298 212.436C223.671 213.394 225.536 212.061 226.8 210.811C226.846 210.728 226.892 210.666 226.939 210.582C227.848 209.166 229.035 208.311 230.283 207.583C230.777 207.291 231.285 207.145 231.794 206.958C232.379 206.728 233.058 207.082 233.598 206.77C233.736 206.687 234.013 207.124 233.89 207.249C233.428 207.749 232.781 207.666 232.21 207.874C231.069 208.27 230.052 209.103 229.081 209.978C227.74 211.207 225.366 214.394 226.075 216.914C226.214 217.435 225.813 217.123 225.705 216.893C225.181 215.769 225.274 214.478 225.644 213.29C225.181 213.686 224.704 213.998 224.241 214.207C223.932 214.331 223.609 214.269 223.301 214.123C223.624 214.748 223.871 215.436 223.994 216.185C224.133 217.061 223.362 216.248 223.223 215.956C222.746 214.894 222.453 213.957 221.744 213.144C220.865 212.498 220.079 211.832 219 211.519C218.862 211.478 218.476 210.79 218.723 210.79V210.811Z",
    fill: "#C3C3BC",
    opacity: 1.0,
    class: "teeth_18",
    id: "teeth_18",
  },
  {
    type: "path",
    d: "M201.814 265.43C201.814 256.052 204.065 256.052 205.94 252.301L212.317 245.174C213.782 245.174 216.068 246.674 216.068 246.674C216.068 246.674 219.82 247.425 220.945 248.55C223.946 248.55 226.947 252.301 226.947 252.301L228.072 253.426L229.948 256.052L231.073 259.053V265.43C231.073 265.43 222.445 286.062 207.617 288.688C205.567 289.051 207.066 278.184 207.066 278.184L202.939 268.056C202.939 268.056 201.814 266.546 201.814 265.43Z",
    fill: "#FAF9F5",
    opacity: 0.8,
    class: "teeth_20",
    id: "teeth_20",
  },
  {
    type: "path",
    d: "M205.125 258.581C205.985 258.493 206.823 258.228 207.684 258.162C208.346 258.118 208.963 258.228 209.559 258.383C209.625 258.03 210 257.678 210.485 257.392C209.052 257.259 207.706 256.885 206.272 256.775C206.14 256.775 205.235 256.401 205.699 256.268C206.89 255.938 208.346 256.07 209.515 256.07C210.882 256.07 212.074 256.026 213.463 255.762C214.169 255.63 215.978 255.013 216.485 255.343C216.353 255.255 216.353 255.145 216.596 255.167C216.817 255.189 216.949 255.211 217.148 255.277C217.301 255.321 217.875 255.585 217.632 255.783C216.817 256.401 215.603 256.797 214.412 257.039C213.838 257.369 213.198 257.678 212.603 257.986C212.206 258.185 211.875 258.405 211.5 258.625C211.368 258.713 211.279 258.779 211.191 258.868C212.824 259.352 214.743 259.793 215.713 260.739C215.912 260.938 215.757 261.114 215.36 261.048C213.75 260.784 212.029 260.453 210.551 260.012C209.603 259.727 208.809 259.264 207.706 259.176C206.845 259.11 206.073 259.132 205.301 258.934C205.191 258.911 204.662 258.559 205.081 258.515L205.125 258.581Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_20",
    id: "teeth_20",
  },
  {
    type: "path",
    d: "M218.625 256.511C218.779 256.379 218.978 256.269 219.199 256.181C219.464 256.071 219.75 255.983 220.015 255.917C220.721 255.763 221.426 255.829 222.11 255.675C222.155 255.675 222.309 255.675 222.551 255.675C222.551 255.631 222.551 255.609 222.53 255.565C222.11 253.979 220.566 253.252 219.905 251.864C219.794 251.6 219.728 251.269 220.037 251.137C221.647 250.542 224.669 253.032 225.529 254.199C225.772 254.552 226.015 254.882 226.213 255.234C226.985 256.269 227.581 257.37 227.912 258.163C229.257 261.314 227.978 266.225 224.867 267.833C224.625 267.965 224.405 267.833 224.184 267.679C222.573 266.622 222.706 264.816 222.861 263.098C222.861 263.053 222.861 263.009 222.861 262.943C222.816 262.239 222.64 261.731 222.397 261.291C222.375 261.291 222.331 261.269 222.309 261.247C221.735 261.049 221.14 260.851 220.588 260.608C219.441 260.102 218.471 259.111 218.162 257.899C218.007 257.261 218.25 256.82 218.647 256.49L218.625 256.511Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_20",
    id: "teeth_20",
  },
  {
    type: "path",
    d: "M209.647 262.59C210.066 261.974 211.191 261.863 211.852 261.754C213.066 261.578 214.102 261.996 214.742 263.053C214.787 263.141 214.831 263.207 214.874 263.296C215.47 263.824 215.868 264.573 215.316 265.278C214.301 266.555 211.544 265.85 210.507 264.969C209.956 264.507 209.14 263.362 209.647 262.613V262.59Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_20",
    id: "teeth_20",
  },
  {
    type: "path",
    d: "M169.962 302.324C169.962 302.324 168.484 310.54 178.543 307.104C191.315 302.743 191.315 281.356 191.315 281.356C191.315 281.356 191.426 272.876 186.771 272.083C182.117 271.29 172.168 281.069 172.057 284.593C171.947 288.117 167.492 294.108 169.94 302.324H169.962Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_22",
    id: "teeth_22",
  },
  {
    type: "path",
    d: "M172.057 284.615C172.168 281.09 182.117 271.311 186.771 272.104C186.903 272.126 187.058 272.17 187.191 272.193C185.8 272.259 184.477 273.029 183.374 273.866C180.153 276.333 177.837 278.69 177.506 282.919C177.021 289.108 175.168 295.165 172.719 300.848C171.727 303.161 171.109 305.694 172.057 307.5C169.278 306.156 169.962 302.324 169.962 302.324C167.492 294.108 171.97 288.139 172.08 284.593L172.057 284.615Z",
    fill: "#C4C4BD",
    opacity: 1.0,
    class: "teeth_22",
    id: "teeth_22",
  },
  {
    type: "path",
    d: "M182.271 302.677C189.705 298.646 190.125 280.651 190.125 280.651C190.125 280.651 190.279 274.527 187.323 274.527C184.367 274.527 179.624 281.576 179.514 283.779C179.36 286.84 176.426 305.848 182.271 302.677Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_22",
    id: "teeth_22",
  },
  {
    type: "path",
    d: "M187.633 276.421C188.713 277.369 188.625 279.395 188.669 280.673C188.713 282.06 188.713 284.02 188.051 285.43C187.941 285.892 187.786 286.355 187.633 286.818C187.257 287.853 186.353 287.897 185.713 287.082C184.764 285.915 184.875 284.065 184.743 282.655C184.61 281.201 184.61 273.778 187.654 276.421H187.633Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_22",
    id: "teeth_22",
  },
  {
    type: "path",
    d: "M205.993 289.174C208.003 287.352 208.431 285.685 208.431 283.059C208.806 277.057 207.731 266.554 201.354 265.428C208.856 264.678 210.307 283.434 209.931 286.81C209.931 287.935 208.106 287.518 207.681 287.935C208.624 287.009 205.022 290.085 206.02 289.188L205.993 289.174Z",
    fill: "#C4C4BD",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M186.727 294.173C186.727 294.173 188.956 301.463 199.654 298.27C210.352 295.054 208.323 277.676 208.323 277.676C208.323 277.676 206.404 264.482 200.007 265.451C195.088 266.2 189.198 268.755 189.066 272.389C188.956 276.002 184.147 285.759 186.727 294.173Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_21",
    id: "teeth_21",
  },
  {
    type: "path",
    d: "M200.801 267.939C200.801 267.939 202.103 266.31 204.441 269.041C206.779 271.772 207.64 279.921 206.802 286.397C205.963 292.873 201.794 296.397 198.331 296.661C194.845 296.947 193.323 270.01 200.823 267.918L200.801 267.939Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_21",
    id: "teeth_21",
  },
  {
    type: "path",
    d: "M201.485 269.901C201.617 268.69 202.676 268.47 203.47 269.241C203.647 269.416 203.801 269.615 203.933 269.813C205.897 271.576 205.742 276.223 205.61 278.425C205.566 279.306 205.61 281.377 204.242 281.047C202.455 280.628 202.059 277.698 201.816 276.289C201.441 274.108 201.242 272.06 201.485 269.879V269.901Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_21",
    id: "teeth_21",
  },
  {
    type: "path",
    d: "M149.513 307.06C149.513 307.06 149.8 314.725 160.455 311.685C171.109 308.646 174.616 285.651 174.616 285.651C174.616 285.651 175.521 279.725 170.624 278.977C165.749 278.228 150.263 281.113 150.153 284.527C150.042 287.941 146.954 299.13 149.513 307.081V307.06Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_23",
    id: "teeth_23",
  },
  {
    type: "path",
    d: "M149.513 307.06C149.513 307.06 149.8 314.725 160.455 311.685C171.109 308.646 174.616 285.651 174.616 285.651C174.616 285.651 175.521 279.725 170.624 278.977C165.749 278.228 150.263 281.113 150.153 284.527C150.042 287.941 146.954 299.13 149.513 307.081V307.06Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_23",
    id: "teeth_23",
  },
  {
    type: "path",
    d: "M155.051 281.863C152.602 283.074 152.183 285.035 152.072 287.612C151.764 294.065 149.381 300.342 149.47 306.972C146.955 299.043 150.021 287.92 150.132 284.506C150.198 282.788 154.124 281.202 158.624 280.145C157.455 280.783 156.242 281.246 155.028 281.841L155.051 281.863Z",
    fill: "#C4C4BD",
    opacity: 1.0,
    class: "teeth_23",
    id: "teeth_23",
  },
  {
    type: "path",
    d: "M152.933 304.064C152.933 304.064 153.154 310.43 162.021 307.919C170.889 305.408 173.801 286.268 173.801 286.268C173.801 286.268 174.55 281.356 170.492 280.717C166.433 280.079 153.572 282.479 153.485 285.321C153.396 288.162 150.815 297.457 152.955 304.064H152.933Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_23",
    id: "teeth_23",
  },
  {
    type: "path",
    d: "M165.241 297.038C165.77 294.438 166.234 291.795 166.278 289.13C166.323 285.892 166.543 282.963 170.249 282.281C170.999 282.148 171.726 283.228 171.991 283.778C172.3 284.417 172.366 285.254 172.278 286.157C172.388 288.58 171.837 290.959 171.043 293.293C170.161 295.958 168.749 300.232 166.455 302.016C165.815 302.5 164.778 301.025 164.69 300.518C164.514 299.328 164.977 298.227 165.219 297.038H165.241Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_23",
    id: "teeth_23",
  },
  {
    type: "path",
    d: "M127.565 309.637C127.565 309.637 129.748 318.161 140.448 314.945C151.146 311.729 151.322 287.391 151.322 287.391C151.322 287.391 152.227 281.114 147.33 280.321C142.433 279.528 127.013 278.955 126.881 282.567C126.771 286.179 126.572 300.144 127.565 309.637Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_24",
    id: "teeth_24",
  },
  {
    type: "path",
    d: "M142.102 282.236C142.102 282.236 148.587 281.509 149.492 285.43C150.396 289.372 149.535 310.208 139.102 313.116C139.102 313.116 133.962 316.045 130.542 309.9C127.124 303.755 129.087 285.826 129.087 285.826C129.087 285.826 130.101 281.201 133.653 281.641C137.227 282.081 142.102 282.214 142.102 282.214V282.236Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_24",
    id: "teeth_24",
  },
  {
    type: "path",
    d: "M141.836 303.756C141.969 304.175 142.83 305.629 143.469 305.144C146.558 302.721 152.293 283.492 144.396 284.77C144.285 284.77 144.264 284.858 144.285 284.946C144.241 284.946 144.197 284.946 144.175 284.946C141.065 285.893 142.08 290.409 142.057 293.007C142.057 295.32 142.014 297.589 141.925 299.901C141.881 301.201 141.462 302.501 141.836 303.756Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_24",
    id: "teeth_24",
  },
  {
    type: "path",
    d: "M40.5128 248.923C40.5128 248.923 44.0208 250.835 42.3884 246.672C41.6382 245.922 42.0195 245.1 42.0195 245.1C43.1387 243.296 42.7915 237.06 42.196 234.461C40.8063 230.629 39.8798 226.554 37.1224 223.471C36.968 223.294 36.9915 223.029 36.9915 222.627C36.0563 221.978 26.1352 224.233 26.1352 224.233C26.1352 224.233 17.7578 227.308 17.6916 227.043C15.6812 227.847 14.475 234.27 14.475 234.27C14.475 235.283 12.4645 237.883 12.4645 237.883C12.9719 245.966 13.5044 244.034 13.5043 250.048C17.6916 262.052 23.2574 267.304 33.3856 251.549L40.5128 248.923Z",
    fill: "#FAF9F5",
    opacity: 0.8,
    class: "teeth_30",
    id: "teeth_30",
  },
  {
    type: "path",
    d: "M16.1883 256.816C16.1883 256.639 16.2765 256.53 16.3868 256.464C13.5191 250.428 12.9015 243.909 14.6442 237.323C15.3721 234.592 15.9456 231.112 18.306 229.218C20.8428 227.169 23.9531 225.98 26.4899 223.953C24.637 224.284 22.8722 224.967 21.1075 225.671C19.1222 226.464 16.9604 226.971 16.0339 229.13C15.1294 231.266 14.975 234.768 13.2765 236.464C11.2691 238.469 9.2838 237.103 7.76172 234.944C8.64407 238.909 9.747 242.873 11.2029 246.662C12.5926 250.319 14.2912 253.798 16.2545 257.234C16.2545 257.081 16.2104 256.948 16.2104 256.794L16.1883 256.816Z",
    fill: "#DEDED4",
    opacity: 1.0,
    class: "teeth_30",
    id: "teeth_30",
  },
  {
    type: "path",
    d: "M19.8941 235.54C19.0338 234.615 18.0853 235.364 17.4897 236.179C16.6956 236.773 16.4529 238.425 16.3646 239.372C15.9897 243.514 16.2985 249.328 18.747 252.874C19.2323 253.58 20.3132 252.081 20.2912 251.575C20.1368 248.139 19.9382 245.011 20.8427 241.619C21.4603 239.306 21.6588 237.479 19.8941 235.562V235.54Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_30",
    id: "teeth_30",
  },
  {
    type: "path",
    d: "M33.6592 239.438C33.2622 239.086 32.2254 239.637 31.8945 239.901C31.4313 240.231 31.0783 240.694 30.7915 241.156C30.5048 241.597 30.0857 242.544 30.593 242.919C30.593 243.051 30.6151 243.183 30.6592 243.315C30.7695 243.667 31.2327 243.58 31.4754 243.448C31.674 243.337 31.8945 243.205 32.093 243.073C32.1813 243.006 32.2695 242.919 32.4681 242.919C33.5048 242.874 34.4313 242.015 34.6739 241.024C34.8725 240.209 34.2328 239.879 33.7034 239.416L33.6592 239.438Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_30",
    id: "teeth_30",
  },
  {
    type: "path",
    d: "M38.0931 235.474C37.2548 235.452 36.4387 235.584 35.6225 235.452C34.696 235.298 33.7474 234.902 32.8651 234.615C32.3577 234.439 31.8504 234.307 31.365 234.196C32.2695 233.492 33.1298 232.742 34.0783 232.06C34.4092 231.817 34.7622 230.849 34.0783 231.289C33.2621 231.817 32.446 232.06 31.5857 232.434C30.7915 232.787 30.1518 233.271 29.4018 233.69C29.2033 233.8 29.0047 233.91 28.8282 233.998C27.7474 232.368 24.6812 231.069 22.9385 231.84C22.762 231.928 22.1223 232.589 22.4311 232.787C23.9753 233.756 26.093 235.298 26.865 236.971C27.1077 237.478 27.5709 239.505 27.2841 239.989C26.7106 240.981 26.4018 241.817 26.3135 242.985C26.2694 243.535 26.9753 243.117 27.1297 242.94C27.3503 242.72 27.5488 242.478 27.6592 242.17C27.7033 242.015 27.7474 241.839 27.6592 241.729C27.9238 240.386 28.8503 239.395 29.0929 238.007C29.2253 237.236 29.3577 236.553 29.3356 235.87C30.5047 235.848 31.696 236.333 32.8651 236.597C34.3871 236.971 35.6886 237.17 37.2548 236.994C37.7181 236.95 38.6887 235.474 38.071 235.452L38.0931 235.474Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_30",
    id: "teeth_30",
  },
  {
    type: "path",
    d: "M69.3969 273.683C64.1452 267.681 64.1452 270.682 55.8063 259.836C53.5122 256.114 48.6151 254.308 46.9827 250.145C45.6371 248.405 44.2915 246.709 42.1297 245.872C40.5127 245.246 38.262 245.872 38.262 245.872C36.7616 245.924 34.5108 247.049 34.5108 247.049L29.6343 250.425C28.1338 251.551 26.6333 252.301 26.6333 252.301C25.1329 253.426 24.3826 254.927 23.6324 256.427C22.8822 257.928 22.132 259.836 23.2573 263.554C29.6765 280.382 30.3845 275.933 46.9827 291.688L65.2706 277.809L69.3969 273.683Z",
    fill: "#FAF9F5",
    opacity: 0.8,
    class: "teeth_29",
    id: "teeth_29",
  },
  {
    type: "path",
    d: "M25.6957 253.45C24.0192 255.411 23.556 257.613 22.8501 260.014C22.453 261.336 21.9898 262.878 20.4897 263.252C20.3133 263.296 20.1589 263.296 19.9824 263.296C22.0118 266.357 24.2398 269.397 26.6663 272.547C25.1442 268.891 23.6442 265.212 23.9089 261.292C24.2398 256.512 27.2619 253.252 30.659 250.301C28.784 250.962 26.9972 251.931 25.6957 253.45Z",
    fill: "#DEDED4",
    opacity: 1.0,
    class: "teeth_29",
    id: "teeth_29",
  },
  {
    type: "path",
    d: "M35.4901 256.509C35.3356 256.377 35.1371 256.267 34.9165 256.179C34.6518 256.069 34.365 255.981 34.1003 255.915C33.3944 255.761 32.6885 255.827 32.0047 255.673C31.9606 255.673 31.8062 255.673 31.5635 255.673C31.5635 255.629 31.5635 255.607 31.5855 255.563C32.0047 253.977 33.5488 253.25 34.2106 251.862C34.343 251.598 34.3871 251.267 34.0783 251.135C32.468 250.54 29.4459 253.03 28.5856 254.197C28.3208 254.55 28.1002 254.88 27.9017 255.232C27.1517 256.267 26.534 257.368 26.2032 258.161C24.8576 261.312 26.1369 266.223 29.2473 267.831C29.49 267.963 29.7105 267.831 29.9311 267.677C31.5414 266.62 31.4091 264.814 31.2547 263.096C31.2547 263.051 31.2547 263.007 31.2547 262.941C31.3209 262.237 31.4753 261.73 31.718 261.289C31.74 261.289 31.7841 261.267 31.8062 261.245C32.3797 261.047 32.9753 260.849 33.5268 260.606C34.6738 260.1 35.6445 259.109 35.9533 257.897C36.1077 257.259 35.865 256.818 35.4679 256.488L35.4901 256.509Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_29",
    id: "teeth_29",
  },
  {
    type: "path",
    d: "M44.4904 262.59C44.0713 261.974 42.9462 261.863 42.2844 261.754C41.0712 261.577 40.0344 261.996 39.3948 263.053C39.3506 263.141 39.3064 263.207 39.2623 263.295C38.6668 263.824 38.2697 264.573 38.8212 265.278C39.8359 266.555 42.5933 265.85 43.6301 264.969C44.1816 264.506 44.9977 263.361 44.4904 262.613V262.59Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_29",
    id: "teeth_29",
  },
  {
    type: "path",
    d: "M48.9903 258.581C48.13 258.493 47.2918 258.229 46.4315 258.163C45.7697 258.118 45.1299 258.229 44.5564 258.383C44.4902 258.03 44.1153 257.678 43.6299 257.392C45.0638 257.259 46.4094 256.885 47.8433 256.775C47.9756 256.775 48.88 256.401 48.4388 256.268C47.2256 255.938 45.7917 256.07 44.6226 256.07C43.255 256.07 42.0637 256.026 40.674 255.762C39.9682 255.63 38.1593 255.013 37.652 255.343C37.7843 255.255 37.7843 255.145 37.5416 255.167C37.321 255.189 37.1887 255.211 36.9902 255.277C36.8358 255.321 36.2622 255.585 36.5048 255.784C37.321 256.401 38.5343 256.797 39.7255 257.039C40.299 257.37 40.9387 257.678 41.5344 257.986C41.9314 258.185 42.2623 258.405 42.6373 258.625C42.7696 258.713 42.8579 258.779 42.9681 258.868C41.3358 259.352 39.4167 259.793 38.4461 260.74C38.2475 260.938 38.402 261.114 38.799 261.048C40.4093 260.784 42.1299 260.453 43.6079 260.013C44.5564 259.727 45.3505 259.264 46.4535 259.176C47.3138 259.11 48.0859 259.132 48.858 258.934C48.9682 258.911 49.4977 258.559 49.0785 258.515L48.9903 258.581Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_29",
    id: "teeth_29",
  },
  {
    type: "path",
    d: "M52.6517 269.9C52.5193 268.688 51.4826 268.468 50.6664 269.239C50.4899 269.415 50.3355 269.613 50.2031 269.812C48.2399 271.573 48.3943 276.221 48.5266 278.424C48.5708 279.305 48.5266 281.375 49.8943 281.045C51.6811 280.626 52.0782 277.697 52.3208 276.287C52.6958 274.107 52.8723 272.058 52.6517 269.878V269.9Z",
    fill: "white",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M67.4095 294.173C67.4095 294.173 65.1816 301.463 54.483 298.27C43.7843 295.054 45.8137 277.676 45.8137 277.676C45.8137 277.676 47.7328 264.482 54.13 265.451C59.0491 266.2 64.9389 268.755 65.0713 272.389C65.1816 276.001 69.9905 285.759 67.4095 294.173Z",
    fill: "#F3F1E6",
    opacity: 0.8,
    class: "teeth_28",
    id: "teeth_28",
  },
  {
    type: "path",
    d: "M65.0707 272.388C64.9824 269.767 61.8501 267.696 58.2544 266.463C59.6662 267.146 61.0118 267.939 61.9824 269.172C64.2324 272.014 61.4971 276.11 61.3868 279.172C61.1221 285.406 64.7178 291.639 64.4309 297.784C66.7472 296.33 67.4089 294.171 67.4089 294.171C69.9898 285.757 65.181 276.001 65.0707 272.388Z",
    fill: "#C4C4BD",
    opacity: 1.0,
    class: "teeth_28",
    id: "teeth_28",
  },
  {
    type: "path",
    d: "M53.313 267.939C53.313 267.939 52.0116 266.31 49.6733 269.041C47.335 271.772 46.4747 279.921 47.3129 286.397C48.1512 292.873 52.3204 296.397 55.7836 296.661C59.269 296.947 60.7911 270.01 53.291 267.918L53.313 267.939Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_28",
    id: "teeth_28",
  },
  {
    type: "path",
    d: "M84.174 302.324C84.174 302.324 85.652 310.54 75.571 307.104C62.7991 302.743 62.7991 281.356 62.7991 281.356C62.7991 281.356 62.6888 272.876 67.3432 272.083C71.9977 271.29 81.9465 281.069 82.0568 284.593C82.1671 288.117 86.6228 294.108 84.174 302.324Z",
    fill: "#F3F1E6",
    opacity: 1,
    class: "teeth_27",
    id: "teeth_27",
  },
  {
    type: "path",
    d: "M82.0568 284.615C81.9465 281.09 71.9979 271.311 67.3435 272.104C67.2111 272.126 67.0567 272.17 66.9243 272.193C68.3141 272.259 69.6375 273.029 70.7405 273.866C73.9609 276.333 76.2777 278.69 76.6085 282.919C77.0939 289.108 78.9463 295.165 81.395 300.848C82.3876 303.161 83.0051 305.694 82.0568 307.5C84.8364 306.156 84.1522 302.324 84.1522 302.324C86.6009 294.108 82.1453 288.139 82.035 284.593L82.0568 284.615Z",
    fill: "#DBDBD1",
    opacity: 1.0,
    class: "teeth_27",
    id: "teeth_27",
  },
  {
    type: "path",
    d: "M71.8656 302.677C64.4318 298.646 64.0126 280.651 64.0126 280.651C64.0126 280.651 63.8582 274.527 66.8141 274.527C69.7701 274.527 74.5131 281.576 74.6234 283.779C74.7772 286.84 77.7113 305.848 71.8656 302.677Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_27",
    id: "teeth_27",
  },
  {
    type: "path",
    d: "M66.4835 276.421C65.4026 277.369 65.4908 279.395 65.4688 280.673C65.4246 282.06 65.4246 284.02 66.0864 285.43C66.2188 285.892 66.3512 286.355 66.5056 286.818C66.8806 287.853 67.7629 287.897 68.4247 287.082C69.3732 285.915 69.2629 284.065 69.3953 282.655C69.5277 281.201 69.5277 273.778 66.4835 276.421Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_27",
    id: "teeth_27",
  },
  {
    type: "path",
    d: "M88.8947 297.038C88.3651 294.438 87.9022 291.795 87.8579 289.13C87.8136 285.892 87.5931 282.963 83.8869 282.281C83.1374 282.148 82.4089 283.228 82.1441 283.778C81.8358 284.417 81.7697 285.254 81.8575 286.157C81.7697 288.58 82.3212 290.959 83.0931 293.293C83.9754 295.958 85.3874 300.232 87.6816 302.016C88.3208 302.5 89.3576 301.025 89.4237 300.518C89.6007 299.328 89.1371 298.227 88.8947 297.038Z",
    fill: "white",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M104.601 307.06C104.601 307.06 104.314 314.725 93.6596 311.685C83.0047 308.646 79.4974 285.65 79.4974 285.65C79.4974 285.65 78.5933 279.725 83.4901 278.977C88.3652 278.228 103.851 281.113 103.961 284.527C104.071 287.941 107.16 299.13 104.601 307.081V307.06Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_26",
    id: "teeth_26",
  },
  {
    type: "path",
    d: "M104.601 307.06C104.601 307.06 104.314 314.725 93.6596 311.685C83.0047 308.646 79.4974 285.65 79.4974 285.65C79.4974 285.65 78.5933 279.725 83.4901 278.977C88.3652 278.228 103.851 281.113 103.961 284.527C104.071 287.941 107.16 299.13 104.601 307.081V307.06Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_26",
    id: "teeth_26",
  },
  {
    type: "path",
    d: "M99.0636 281.863C101.512 283.073 101.932 285.034 102.042 287.611C102.35 294.064 104.733 300.342 104.645 306.972C107.159 299.042 104.093 287.919 103.983 284.506C103.917 282.788 99.9902 281.202 95.4685 280.145C96.6374 280.783 97.8505 281.246 99.0636 281.84V281.863Z",
    fill: "#C4C4BD",
    opacity: 1.0,
    class: "teeth_26",
    id: "teeth_26",
  },
  {
    type: "path",
    d: "M101.203 304.064C101.203 304.064 100.983 310.43 92.115 307.919C83.2472 305.408 80.3355 286.268 80.3355 286.268C80.3355 286.268 79.586 281.356 83.6448 280.717C87.7036 280.079 100.564 282.479 100.674 285.321C100.762 288.162 103.343 297.457 101.203 304.064Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_26",
    id: "teeth_26",
  },
  {
    type: "path",
    d: "M126.551 309.635C126.551 309.635 124.367 318.16 113.668 314.943C102.969 311.728 102.793 287.389 102.793 287.389C102.793 287.389 101.889 281.112 106.786 280.319C111.683 279.526 127.102 278.953 127.235 282.565C127.345 286.178 127.543 300.142 126.551 309.635Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_25",
    id: "teeth_25",
  },
  {
    type: "path",
    d: "M112.035 282.234C112.035 282.234 105.55 281.507 104.646 285.428C103.741 289.37 104.602 310.207 115.035 313.115C115.035 313.115 120.175 316.043 123.595 309.898C127.013 303.753 125.05 285.824 125.05 285.824C125.05 285.824 124.036 281.199 120.484 281.639C116.91 282.08 112.035 282.212 112.035 282.212V282.234Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_25",
    id: "teeth_25",
  },
  {
    type: "path",
    d: "M112.212 299.9C112.102 297.587 112.079 295.319 112.079 293.006C112.079 290.407 113.072 285.891 109.962 284.944C109.918 284.944 109.874 284.944 109.852 284.944C109.852 284.857 109.852 284.791 109.742 284.768C101.844 283.491 107.601 302.719 110.667 305.142C111.286 305.627 112.168 304.173 112.3 303.754C112.675 302.499 112.278 301.2 112.212 299.9Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_25",
    id: "teeth_25",
  },
  {
    type: "path",
    d: "M211.478 246.672C212.228 247.182 212.933 246.672 214.433 247.047C215.934 247.422 220.06 248.922 220.06 248.922C220.06 248.922 225.744 251.13 227.937 254.174C229.175 255.894 230.188 258.344 230.188 259.051C230.348 260.219 230.74 262.519 230.74 262.519C230.785 262.497 235.008 263.228 239.566 250.423C245.975 232.417 229.973 228.692 229.973 228.692C229.973 228.692 218.749 226.604 215.934 228.291C213.923 229.495 212.889 231.876 211.478 235.708C211.478 242.399 210.728 246.161 211.478 246.672Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_19",
    id: "teeth_19",
  },
  {
    type: "path",
    d: "M216.022 235.474C216.86 235.452 217.677 235.584 218.515 235.452C219.441 235.298 220.389 234.901 221.272 234.615C221.779 234.439 222.287 234.307 222.772 234.196C221.867 233.492 221.007 232.742 220.059 232.06C219.728 231.817 219.375 230.849 220.059 231.289C220.875 231.817 221.691 232.06 222.552 232.434C223.345 232.787 223.985 233.271 224.735 233.69C224.934 233.8 225.132 233.91 225.33 233.998C226.412 232.368 229.478 231.069 231.221 231.84C231.397 231.928 232.037 232.589 231.728 232.787C230.184 233.756 228.066 235.298 227.294 236.971C227.052 237.478 226.588 239.505 226.875 239.989C227.448 240.981 227.735 241.817 227.845 242.985C227.89 243.535 227.184 243.117 227.029 242.94C226.808 242.72 226.61 242.478 226.5 242.17C226.456 242.015 226.412 241.839 226.5 241.729C226.235 240.386 225.309 239.395 225.066 238.007C224.934 237.236 224.802 236.553 224.823 235.87C223.654 235.848 222.463 236.333 221.294 236.597C219.772 236.971 218.47 237.17 216.904 236.994C216.441 236.95 215.47 235.474 216.088 235.452L216.022 235.474Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_19",
    id: "teeth_19",
  },
  {
    type: "path",
    d: "M255.422 100.019C253.216 79.4475 227.936 15.374 190.016 8.96454C157.259 3.43603 133.721 0.660774 127.92 0L127.938 0.00205114C127.938 0.00205114 127.707 2.32529e-05 127.225 1.65008e-05C126.729 0.0220225 126.509 0.0220225 126.509 0.0220225C120.949 0.704821 98.9127 3.48008 66.3312 8.98652C28.4557 15.352 3.17593 79.4475 0.947967 100.019C-1.25795 120.591 9.52898 162.022 9.52898 162.022L15.1761 162.33C15.1761 162.33 20.8011 139.577 24.6394 118.037C28.4777 96.4951 41.8455 79.9756 66.8385 59.668C89.9564 40.8799 122.559 42.1354 127.347 42.4217V42.4658C127.347 42.4658 127.457 42.4658 127.656 42.4658C127.854 42.4658 127.942 42.4658 127.942 42.4658V42.4217C132.795 42.1354 166.413 40.8579 189.553 59.668C214.546 79.9756 227.914 96.4951 231.753 118.037C235.591 139.577 241.215 162.33 241.215 162.33L246.862 162.022C246.862 162.022 257.649 120.591 255.444 100.019H255.422Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M7.12489 117.199C8.97783 109.358 11.2279 101.605 13.522 93.8738C15.7941 86.2529 18.4633 78.7205 21.8824 71.5399C29.0296 56.4963 39.4636 43.1486 53.6917 34.2281C61.3021 29.4486 69.6183 25.9023 78.2438 23.4134C89.6699 20.1096 101.582 17.8849 113.383 16.4092C126.509 14.7793 139.832 14.2507 153.002 15.5502C164.958 16.7176 177.355 18.9422 188.406 23.8099C207.444 32.2018 220.723 48.7652 229.988 66.9144C235.68 78.0813 239.495 89.6672 242.782 101.737C245.65 112.288 248.959 122.684 251.297 133.366C251.606 134.754 251.893 136.164 252.18 137.551C254.518 124.865 256.503 109.997 255.422 100.019C253.216 79.4475 227.936 15.374 190.017 8.96454C157.26 3.43603 133.722 0.660775 127.921 0C127.921 0 127.615 3.07553e-05 127.268 1.65008e-05C126.763 -4.50584e-06 126.509 0.0220225 126.509 0.0220225C120.95 0.704821 98.9128 3.48008 66.3315 8.98652C28.456 15.352 3.1763 79.4475 0.948337 100.019C-0.0663812 109.424 1.63216 123.168 3.79396 135.348C4.52191 129.247 5.7131 123.191 7.12489 117.221V117.199Z",
    fill: "url(#paint1_radial_2002_6979)",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M64.1693 42.5985C61.3016 41.7615 58.7427 43.3474 56.7353 45.2196C54.9927 46.8495 52.3235 49.6248 52.3456 52.1797C52.3456 52.3339 52.4559 52.3339 52.5662 52.2678C52.6323 52.2678 52.6985 52.2018 52.7647 52.1137C52.7647 52.1137 52.8088 52.0916 52.8088 52.0696C54.1544 50.3516 55.1029 48.4353 56.6471 46.8495C57.4853 45.9685 58.6765 45.1095 59.8015 44.713C60.9266 44.3385 62.206 44.3826 63.3751 44.1182C63.7501 44.0302 64.8972 42.7747 64.1913 42.5764L64.1693 42.5985Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M88.3685 31.806C86.1621 30.5945 83.5377 30.5505 81.2435 31.4315C79.545 32.0703 76.8531 34.3609 76.0376 36.0569C76.0376 36.0569 76.0811 36.0569 76.1036 36.0349C75.8605 36.6737 76.4787 36.8939 77.0744 35.9909C78.0445 34.5152 80.449 33.0174 82.1258 32.5989C83.9346 32.1584 85.8312 33.1055 87.7068 32.9073C87.9716 32.8852 88.7871 32.0042 88.3903 31.7839L88.3685 31.806Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M115.06 25.7471C110.758 23.2802 104.45 26.7823 101.648 30.1743C101.538 30.3065 101.295 30.769 101.648 30.747C103.06 30.6369 104.538 28.8308 105.707 28.1259C108.243 26.5841 111.42 27.0246 114.222 26.9145C114.53 26.9145 115.523 25.9894 115.06 25.7251V25.7471Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M42.6616 57.4659C36.9483 60.3954 32.2277 67.5537 31.0364 73.765C30.9041 74.3818 31.6762 73.699 31.7865 73.5007C34.4997 67.6859 37.61 62.0693 42.6175 57.8844C42.7057 57.8183 42.9704 57.3337 42.6616 57.4659Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M25.2794 84.7999C23.9779 86.2756 22.8749 87.7513 22.0588 89.5354C21.3308 91.1206 20.4484 93.3893 21.1763 95.0856C21.2646 95.2837 21.419 95.1734 21.5734 94.9971C21.6837 94.9093 21.794 94.7773 21.8602 94.5792C22.4337 92.7726 22.8749 90.9668 23.5588 89.1828C24.1102 87.7288 25.1029 86.3851 25.9191 85.064C26.4044 84.2927 25.6764 84.2927 25.2353 84.7774L25.2794 84.7999Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M16.3673 102.375C14.9555 103.894 13.6761 106.471 14.029 108.631C14.029 108.763 14.029 108.829 14.0731 108.916C14.0731 108.916 14.0731 108.939 14.0952 108.961C14.2276 109.159 14.6026 108.652 14.6467 108.564C15.1541 107.396 15.4629 106.163 15.9261 104.996C16.279 104.071 16.9849 103.344 17.1173 102.331C17.1834 101.846 16.4997 102.221 16.3673 102.353V102.375Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M11.2051 116.363C11.2051 116.363 11.4698 115.967 11.2713 115.923C11.2051 115.923 11.1389 115.901 11.0728 115.879C10.9404 115.857 10.7859 116.055 10.7639 116.187C10.0359 116.892 9.61684 118.742 9.4845 119.293C8.73449 122.091 7.83008 125.725 8.95506 128.522C9.13152 128.94 9.72713 128.081 9.77124 127.927C10.3669 125.57 10.2786 123.082 10.6757 120.681C10.8742 119.514 11.0286 118.368 11.2713 117.222C11.3595 116.804 11.558 115.923 11.2051 116.363Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M192.2 42.5985C195.068 41.7615 197.627 43.3474 199.633 45.2196C201.399 46.8495 204.046 49.6248 204.024 52.1797C204.024 52.3339 203.914 52.3339 203.803 52.2678C203.737 52.2678 203.671 52.2018 203.605 52.1137C203.605 52.1137 203.56 52.0916 203.56 52.0696C202.215 50.3516 201.266 48.4353 199.722 46.8495C198.884 45.9685 197.693 45.1095 196.567 44.713C195.443 44.3385 194.164 44.3826 192.994 44.1182C192.619 44.0302 191.472 42.7747 192.178 42.5764L192.2 42.5985Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M168.024 31.806C170.23 30.5945 172.855 30.5505 175.149 31.4315C176.848 32.0703 179.539 34.3609 180.355 36.0569C180.355 36.0569 180.311 36.0569 180.289 36.0349C180.532 36.6737 179.914 36.8939 179.318 35.9909C178.348 34.5152 175.944 33.0174 174.267 32.5989C172.458 32.1584 170.561 33.1055 168.686 32.9073C168.421 32.8852 167.605 32.0042 168.002 31.7839L168.024 31.806Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M141.31 25.7471C145.611 23.2802 151.921 26.7823 154.722 30.1743C154.833 30.3065 155.075 30.769 154.722 30.747C153.31 30.6369 151.832 28.8308 150.663 28.1259C148.126 26.5841 144.95 27.0246 142.148 26.9145C141.84 26.9145 140.847 25.9894 141.31 25.7251V25.7471Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M213.708 57.4659C219.421 60.3954 224.142 67.5537 225.333 73.765C225.466 74.3818 224.694 73.699 224.584 73.5007C221.87 67.6859 218.76 62.0693 213.752 57.8844C213.664 57.8183 213.399 57.3337 213.686 57.4659H213.708Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M231.113 84.7999C232.414 86.2756 233.517 87.7513 234.333 89.5354C235.061 91.1206 235.944 93.3893 235.216 95.0856C235.127 95.2837 234.973 95.1734 234.819 94.9971C234.709 94.9093 234.598 94.7773 234.532 94.5792C233.958 92.7726 233.517 90.9668 232.833 89.1828C232.282 87.7288 231.289 86.3851 230.473 85.064C229.988 84.2927 230.716 84.2927 231.157 84.7774L231.113 84.7999Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M240.003 102.375C241.436 103.894 242.694 106.471 242.341 108.631C242.341 108.763 242.341 108.829 242.297 108.916C242.297 108.916 242.297 108.939 242.275 108.961C242.142 109.159 241.767 108.652 241.724 108.564C241.216 107.396 240.907 106.163 240.444 104.996C240.091 104.071 239.385 103.344 239.252 102.331C239.186 101.846 239.87 102.221 240.003 102.353V102.375Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M245.164 116.363C245.164 116.363 244.922 115.967 245.098 115.923C245.164 115.923 245.23 115.901 245.296 115.879C245.429 115.857 245.583 116.055 245.605 116.187C246.333 116.892 246.752 118.742 246.884 119.293C247.635 122.091 248.539 125.725 247.414 128.522C247.238 128.94 246.642 128.081 246.598 127.927C246.002 125.57 246.091 123.082 245.694 120.681C245.517 119.514 245.34 118.368 245.098 117.222C245.01 116.804 244.811 115.923 245.164 116.363Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M249.731 145.612C249.532 142.594 249.466 139.532 248.65 136.604C247.723 133.299 246.4 130.238 245.87 126.802C245.385 123.586 245.231 120.084 244.084 117.022C243.069 114.335 240.907 112.287 239.936 109.622C238.988 107.001 239.01 104.203 237.532 101.759C235.525 98.4547 232.811 95.8116 231.532 92.2653C231.333 94.1153 230.981 95.9437 230.208 97.6835C229.987 98.1906 229.238 97.7495 229.458 97.2431C230.054 95.9219 230.363 94.534 230.561 93.1243C230.363 93.0583 230.208 92.882 230.275 92.6179C231.774 86.781 227.737 82.5962 225.135 77.8382C222.51 73.0588 220.789 68.1471 217.061 64.0282C215.031 61.8036 212.737 59.6451 210.112 58.1473C208.15 57.024 205.789 56.4734 204.002 55.0637C199.899 51.8039 196.855 46.0332 190.767 47.7291C191.318 49.8436 192.31 51.6938 193.635 53.4338C193.966 53.8743 193.215 54.3148 192.884 53.8743C191.451 51.936 190.37 49.8877 189.84 47.5309C189.796 47.2886 189.906 47.0683 190.149 47.0022C190.325 46.9362 190.48 46.9142 190.634 46.8701C187.502 46.7379 184.392 49.1828 181.326 47.619C177.598 45.7247 176.141 41.65 173.207 38.9188C171.046 36.9144 168.575 35.7911 165.707 36.9365C163.965 37.6192 161.891 38.9848 159.95 38.8527C156.597 38.6105 154.788 34.6238 152.693 32.4872C148.744 28.4345 143.802 26.298 138.398 29.0953C136.479 30.0864 134.803 31.3639 133.06 32.6414C132.045 33.3903 131.009 34.0731 129.751 34.3154C126.045 35.0642 122.824 30.8793 119.648 29.69C116.45 28.5006 113.163 28.3243 110.163 29.3375C110.118 29.4477 110.03 29.5358 109.92 29.5799C109.104 29.9103 108.265 30.2186 107.471 30.6371C107.339 30.7032 107.229 30.7692 107.096 30.8353C106.567 31.1877 106.059 31.5842 105.574 32.0247C105.42 32.1789 105.221 32.1568 105.067 32.0907C104.471 32.5313 103.898 32.9938 103.413 33.5445C102.596 34.4475 102.067 35.7471 101.14 36.54C99.795 37.6853 98.2067 38.0818 96.5082 37.5312C94.0377 36.7602 92.2724 34.866 89.471 34.9541C87.0665 35.0202 84.9268 36.0334 83.0302 37.421C79.3683 40.1082 76.1918 44.0287 71.6916 45.3723C68.7797 46.2314 65.6694 46.2534 62.7796 47.1785C59.3164 48.2797 57.4414 50.5264 54.9045 52.9052C52.6986 54.9756 50.6472 55.5923 47.7795 56.4073C44.7574 57.2663 42.3309 59.1605 40.2573 61.4732C36.6176 65.548 34.2573 70.3056 31.919 75.1951C31.3896 76.319 30.8822 77.5524 30.3307 78.7415C30.3969 78.8293 30.441 78.9395 30.3969 79.0941C29.6248 82.1558 27.3307 84.2257 25.7645 86.8688C23.9335 89.9305 23.6027 93.7192 22.2571 97.0233C19.4997 103.807 15.4408 110.084 13.3232 117.133C12.1319 121.053 11.9334 125.128 10.8967 129.07C9.81573 133.123 8.62458 137.088 8.22748 141.295C7.58775 148.255 8.33776 155.259 10.0584 162.021L15.1982 162.307C15.1982 162.307 20.8232 139.555 24.6615 118.013C28.4998 96.4726 41.8676 79.9531 66.8606 59.6451C89.9789 40.857 122.582 42.1126 127.368 42.3989V42.4429C127.368 42.4429 127.479 42.4429 127.678 42.4429C127.876 42.4429 127.964 42.4429 127.964 42.4429V42.3989C132.817 42.1126 166.436 40.8351 189.575 59.6451C214.569 79.9531 227.936 96.4726 231.774 118.013C235.613 139.555 241.238 162.307 241.238 162.307L246.885 161.999C246.885 161.999 248.407 156.14 250.194 147.748C249.951 147.087 249.819 146.383 249.775 145.612H249.731Z",
    fill: "#FDA2AC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M35.1022 163.116C37.7956 160.442 39.9503 154.425 38.8729 145.065C37.7956 136.374 27.0222 114.981 16.7874 119.661C8.70737 123.003 4.39726 134.369 6.55194 148.408C8.1687 162.447 10.3234 164.453 14.6327 165.789C18.4034 167.127 20.0195 164.453 23.2515 164.453C25.9448 164.453 30.2542 167.796 35.1022 163.116Z",
    fill: "#FAF9F5",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M35.102 163.116C37.7953 160.442 39.95 154.425 38.8727 145.065C37.7953 136.374 27.0219 114.981 16.7872 119.661C8.70713 123.003 4.39701 134.369 6.5517 148.408C8.16846 162.447 10.3231 164.453 14.6325 165.789C18.4032 167.127 20.0192 164.453 23.2512 164.453C25.9446 164.453 30.254 167.796 35.102 163.116Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.0158 167.126C11.3998 165.121 11.3998 160.441 12.4771 157.099C13.5545 153.756 10.3224 149.076 8.70642 142.391C7.09041 135.706 15.1705 130.357 25.406 130.357C35.6407 129.689 40.4887 139.048 41.0274 147.739C41.5661 157.099 37.2567 165.789 30.7927 166.458C23.7899 168.464 15.1705 169.132 13.0158 167.126Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.0165 167.126C11.4005 165.121 11.4005 160.441 12.4778 157.099C13.5552 154.425 9.78447 149.076 8.70713 142.391C7.09112 135.706 15.1712 130.357 24.8672 130.357C35.102 129.689 39.95 139.048 40.4894 147.739C41.0281 157.099 36.718 165.789 30.2539 166.458C23.7899 168.464 15.7098 169.132 13.0165 167.126Z",
    fill: "#90",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.5562 167.126C11.9402 165.12 11.9402 160.44 13.0175 157.097C14.0949 154.424 10.3242 149.075 9.24682 142.39C7.63005 135.704 15.7109 131.024 25.4069 130.356C35.103 129.687 40.4897 139.047 41.0284 147.738C41.567 157.097 37.2577 165.788 30.7936 166.457C24.3296 167.794 15.7109 169.131 13.5562 167.126Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.5562 166.457C11.9402 164.452 11.9402 159.772 13.0175 156.43C14.0949 153.756 10.3242 148.407 9.24682 141.722C7.63005 135.036 15.7109 130.357 25.4069 129.688C35.103 129.02 40.4897 138.379 41.0284 147.07C41.567 156.43 37.2577 165.12 30.7936 165.789C24.3296 167.795 15.7109 169.132 13.5562 166.457Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.5562 166.457C11.9402 164.452 11.9402 159.772 13.0175 156.43C14.0949 153.756 10.3242 148.407 9.24682 141.722C7.63005 135.036 15.7109 130.357 25.4069 129.688C35.103 129.02 40.4897 138.379 41.0284 147.07C41.567 156.43 37.2577 165.12 30.7936 165.789C24.3296 167.795 15.7109 169.132 13.5562 166.457Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.5562 166.457C11.9402 164.452 11.9402 159.772 13.0175 156.43C14.0949 153.756 10.3242 148.407 9.24682 141.722C7.63005 135.036 15.7109 130.357 25.4069 129.688C35.103 129.02 40.4897 138.379 41.0284 147.07C41.567 156.43 37.2577 165.12 30.7936 165.789C24.3296 167.795 15.7109 169.132 13.5562 166.457Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M13.5562 166.459C11.9402 164.453 12.4788 159.774 13.0175 157.099C14.0949 154.425 10.8628 149.745 9.24682 143.06C7.63005 136.374 15.7109 131.695 25.4069 131.026C35.103 130.358 40.4897 139.049 41.0284 148.408C41.567 157.099 37.2577 165.791 30.7936 167.127C24.3296 167.796 15.7109 169.133 13.5562 166.459Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.094 166.457C12.478 164.452 13.0167 159.772 13.5553 157.098C14.6327 154.424 11.4007 149.744 9.78466 143.059C8.16864 136.374 16.2487 131.694 25.9455 131.025C35.6416 131.025 41.0283 139.047 41.5669 148.407C42.1056 157.098 37.7963 165.789 31.3322 167.127C24.3295 167.795 16.2487 168.463 14.094 166.457Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.094 166.457C12.478 164.452 13.0167 159.772 13.5553 157.098C14.6327 154.424 11.4007 149.744 9.78466 143.059C8.16864 136.373 16.2487 131.693 25.9455 131.025C35.6416 131.025 41.0283 139.047 41.5669 148.407C42.1056 157.098 37.7963 165.789 31.3322 167.126C24.3295 167.126 16.2487 168.463 14.094 166.457Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.0941 166.457C12.4781 164.452 13.0168 159.772 13.5554 157.098C14.6328 154.424 11.4008 149.744 9.78475 143.059C8.16874 136.373 16.2488 131.693 25.9456 131.025C35.6417 131.025 41.0284 139.047 41.0284 148.407C41.567 157.098 37.2577 165.789 30.7936 167.126C24.8683 167.126 16.2488 168.463 14.0941 166.457Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.094 165.789C12.478 163.784 13.0166 159.104 13.5553 156.43C14.6327 153.755 11.4006 149.076 9.78463 142.391C8.16861 135.705 16.2487 131.026 25.9455 130.357C35.6415 130.357 41.0282 138.379 41.0282 147.739C41.5669 156.43 37.2576 165.121 30.7935 166.458C24.8681 167.126 16.2487 168.463 14.094 165.789Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.0941 165.79C12.4781 163.784 13.0168 159.104 13.5554 156.43C14.6328 153.756 11.4008 149.076 9.78475 142.391C8.16874 135.705 16.2488 131.025 25.9456 131.025C35.6417 131.025 41.0284 139.048 41.0284 148.408C41.567 157.098 37.2577 165.79 30.7936 167.127C24.8683 167.127 16.2488 168.464 14.0941 165.79Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.6334 165.789C13.0174 163.784 13.5561 159.104 14.0947 156.43C15.1721 153.755 11.9401 149.076 10.324 142.391C8.70803 135.705 16.7881 131.025 25.9455 131.025C35.6415 131.025 40.4896 139.048 41.0282 148.408C41.5669 157.098 37.2576 165.789 30.7935 166.458C24.8681 167.126 16.7881 168.463 14.6334 165.789Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.6335 165.791C13.0175 163.785 13.5562 159.106 14.0949 156.431C15.1722 153.757 11.9402 149.077 10.3234 142.392C8.70739 135.706 16.2495 131.026 25.9456 131.026C35.6417 131.026 40.4897 139.05 41.0284 147.74C41.567 156.431 37.2577 165.123 30.7936 165.791C24.8683 167.128 16.7882 167.796 14.6335 165.791Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.6335 165.791C13.0175 163.785 13.5562 159.106 14.0949 156.431C15.1722 153.757 11.9402 149.077 10.3234 142.392C8.70739 135.706 16.2495 131.026 25.9456 131.026C35.6417 131.026 40.4897 139.05 41.0284 147.74C41.567 156.431 37.2577 165.123 30.7936 165.791C24.8683 167.128 16.7882 167.796 14.6335 165.791Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.6334 165.79C13.0174 163.784 13.5561 159.105 14.0948 156.43C15.1721 153.757 11.9401 149.077 10.3233 142.391C8.7073 135.706 16.2494 131.027 25.9455 131.027C35.6416 131.027 40.4896 139.049 41.0283 147.74C41.5669 156.431 37.2576 165.122 31.3322 165.79C24.8682 166.459 16.7881 167.796 14.6334 165.79Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M14.6334 165.79C13.0174 163.784 13.5561 159.105 14.0948 156.43C15.1721 153.757 11.9401 149.077 10.3233 142.391C8.7073 135.706 16.2494 131.027 25.9455 131.027C35.6416 131.027 40.4896 139.049 41.0283 147.74C41.5669 156.431 37.2576 165.122 31.3322 165.79C24.8682 166.459 16.7881 167.796 14.6334 165.79Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M15.1707 165.12C13.5547 163.115 14.0934 158.435 14.6321 155.761C15.7094 153.086 12.4774 148.407 10.8614 141.722C9.24538 135.036 16.7868 130.356 26.4836 130.356C36.1797 130.356 41.0277 138.379 41.5664 147.07C42.105 155.761 37.7957 164.452 31.8703 165.12C25.4062 166.457 16.7868 167.795 15.1707 165.12Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M15.1707 165.12C13.5547 163.115 14.0934 158.435 14.6321 155.761C15.7094 153.086 12.4774 148.407 10.8614 141.722C9.24538 135.036 16.7868 130.356 26.4836 130.356C36.1797 130.356 41.0277 138.379 41.5664 147.07C42.105 155.761 37.7957 164.452 31.8703 165.12C25.4062 166.457 17.3254 167.795 15.1707 165.12Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M15.1707 165.12C13.5547 163.115 14.0934 158.435 14.6321 155.761C15.7094 153.086 12.4774 148.407 10.8614 141.722C9.24538 135.036 16.7868 130.356 26.4836 130.356C36.1797 130.356 41.0277 138.379 41.5664 147.07C42.105 155.761 37.7957 163.783 31.8703 165.12C25.4062 166.457 17.3254 167.795 15.1707 165.12Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M15.1706 165.121C13.5546 163.116 14.0933 158.436 14.632 155.762C15.7093 153.087 12.4773 148.408 10.8613 141.723C9.24525 135.037 16.7866 131.026 26.4835 130.357C35.6408 130.357 41.0275 138.38 41.0275 147.07C41.5662 155.762 37.2569 163.784 31.3315 165.121C25.4061 166.458 17.3253 167.126 15.1706 165.121Z",
    fill: "#FAF9F5",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M32.3675 158.437C31.5632 158.457 30.78 158.342 29.9967 158.457C29.1077 158.589 28.1977 158.932 27.3507 159.179C26.8638 159.331 26.3776 159.446 25.9117 159.541C26.7797 160.15 27.605 160.797 28.515 161.386C28.8324 161.596 29.1715 162.433 28.515 162.053C27.7318 161.596 26.9485 161.386 26.1233 161.063C25.361 160.758 24.7473 160.34 24.0279 159.978C23.8373 159.884 23.6467 159.788 23.4772 159.712C22.4403 161.12 19.4979 162.242 17.8256 161.577C17.6561 161.5 17.0424 160.929 17.3387 160.758C18.8205 159.921 20.8529 158.589 21.5933 157.144C21.8259 156.706 22.2708 154.955 21.9955 154.537C21.4455 153.681 21.1492 152.957 21.0644 151.949C21.0216 151.473 21.6991 151.835 21.8477 151.987C22.0592 152.177 22.2498 152.387 22.3556 152.653C22.3976 152.786 22.4403 152.939 22.3556 153.034C22.6091 154.195 23.4982 155.051 23.7315 156.249C23.8583 156.915 23.9851 157.505 23.9641 158.095C25.0857 158.114 26.2291 157.695 27.3507 157.467C28.8114 157.144 30.0605 156.972 31.5632 157.124C32.0081 157.163 32.9392 158.437 32.3465 158.457L32.3675 158.437Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_1",
    id: "teeth_1",
  },
  {
    type: "path",
    d: "M38.008 103.454C34.9418 101.229 29.0519 96.5599 26.1843 101.031C26.1402 101.119 26.0961 101.208 26.052 101.274C22.0151 104.115 18.9048 107.132 16.3018 111.956C13.3018 117.573 12.4635 124.532 12.1988 130.942C12.1106 133.211 11.8679 137.175 12.2871 140.744C13.39 142.968 14.8018 145.06 16.8974 146.162C19.4342 147.484 22.3019 147.594 25.0593 147.616C27.5741 147.616 30.0888 147.902 32.6035 147.924C32.6917 147.924 32.802 147.902 32.8902 147.88C34.5005 147.55 36.2653 146.955 37.9198 146.096C39.0668 144.928 40.0816 143.607 40.8977 142.109C43.3463 137.682 43.8095 132.418 44.4492 127.374C44.9566 123.431 45.4199 119.489 46.0154 115.568C45.3316 110.414 42.3316 106.604 37.9859 103.454H38.008Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_2",
    id: "teeth_2",
  },
  {
    type: "path",
    d: "M23.7572 146.316C25.0808 145.039 25.3896 143.189 23.6469 142.109C22.941 141.669 22.2351 141.317 21.4631 141.052C18.9263 140.149 17.4924 139.18 16.8527 136.427C16.7645 136.097 17.1615 135.721 17.4924 135.942C18.1542 136.405 19.0145 137.088 19.8087 137.22C21.4631 137.462 23.2057 136.471 21.4851 135.391C20.691 134.885 19.8307 134.488 19.0807 133.916C17.8454 132.991 16.5439 131.977 16.0145 130.458C14.6689 126.603 16.2792 121.823 14.4042 118.211C14.1174 118.453 13.8747 118.762 13.6321 119.07C12.6836 122.947 12.3085 127.043 12.1541 130.964C12.0659 133.233 11.8233 137.197 12.2424 140.766C13.3454 142.991 14.7571 145.083 16.8527 146.184C18.3307 146.955 19.8969 147.307 21.5072 147.484C22.3454 147.263 23.1396 146.911 23.7352 146.338L23.7572 146.316Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_2",
    id: "teeth_2",
  },
  {
    type: "path",
    d: "M38.0078 103.454C34.9416 101.229 29.0519 96.5599 26.1842 101.031C26.1401 101.119 26.0959 101.208 26.0518 101.274C22.015 104.115 18.9046 107.132 16.3017 111.956C16.059 112.397 15.8385 112.859 15.6399 113.322C15.8163 113.167 15.9929 113.013 16.1914 112.881C16.4561 112.683 16.8311 112.947 16.8311 113.256C16.7649 118.674 14.0296 126.779 19.412 130.502C22.1694 132.418 25.765 132.836 29.0298 132.903C30.4195 132.925 31.7872 132.946 33.1549 132.661C34.1034 132.462 35.1181 132.132 36.0887 132.132C38.052 132.132 38.074 133.673 37.7211 135.259C37.2578 137.33 38.1181 138.519 38.9343 140.259C39.1991 140.854 39.3314 141.492 39.3535 142.153C39.3535 142.66 39.3535 143.585 39.2652 144.643C39.8828 143.871 40.4343 143.034 40.9417 142.153C43.3903 137.726 43.8535 132.462 44.4932 127.418C45.0006 123.475 45.4639 119.533 46.0594 115.612C45.3756 110.458 42.3756 106.648 38.0299 103.498L38.0078 103.454Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_2",
    id: "teeth_2",
  },
  {
    type: "path",
    d: "M38.2726 136.868C38.449 136.691 38.6034 136.515 38.7578 136.339C37.2578 136.647 35.6254 136.625 34.1916 136.295C34.0372 136.251 33.8828 136.207 33.7284 136.163C32.6254 135.921 31.5224 135.59 30.3974 135.238C30.0004 135.238 29.6033 135.304 29.1621 135.48C27.8165 136.009 25.9856 137.176 24.265 137.705C21.9488 138.806 19.765 138.124 17.9561 136.647C19.9194 139.137 21.5517 139.709 24.5077 138.498C25.2136 138.079 25.8974 137.639 26.6033 137.22C27.0665 138.586 28.3901 139.533 28.5886 141.031C28.8091 142.594 27.7503 143.828 27.5077 145.194C27.5077 145.216 27.5518 145.237 27.5518 145.26C27.7724 145.127 27.9709 144.995 28.1915 144.841C28.6106 143.74 29.3386 142.903 29.8019 141.867C29.9562 142.11 30.1327 142.352 30.265 142.528C30.7724 143.168 31.5886 143.784 32.3166 144.114C33.0445 144.444 33.9931 144.114 34.7651 143.894C34.5445 143.828 34.3018 143.762 34.0813 143.674C32.2945 143.168 30.618 142.044 30.2871 140.436C30.243 140.414 30.2209 140.392 30.1768 140.37C30.1768 140.216 30.1768 140.04 30.1768 139.864C30.1106 138.784 29.4489 138.124 28.6989 137.529C28.6989 137.484 28.6989 137.44 28.6989 137.418C28.6989 137.397 28.6989 137.352 28.6768 137.331C29.4047 137.154 30.1989 136.89 29.8901 136.868C31.4563 137.022 32.8019 137.727 34.4343 137.749C35.846 137.749 37.1034 137.463 38.2284 136.868H38.2726Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_2",
    id: "teeth_2",
  },
  {
    type: "path",
    d: "M39.5734 94.5567C36.8161 92.7291 31.566 88.8744 28.9851 92.5746C28.941 92.6406 28.8969 92.7066 28.8528 92.7726C25.235 95.1299 22.4335 97.6184 20.0952 101.627C17.382 106.275 16.632 112.024 16.3672 117.332C16.2128 120.438 15.7938 123.94 17.4261 126.737C18.9482 129.335 21.6835 130.415 24.5071 130.877C30.066 131.78 37.2352 132.067 41.3603 127.398C44.4265 123.94 44.6912 118.675 45.3088 114.292C45.772 111.032 46.1912 107.772 46.7427 104.535C46.1471 100.262 43.4558 97.1338 39.5734 94.5567Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_3",
    id: "teeth_3",
  },
  {
    type: "path",
    d: "M39.5734 94.5567C36.8161 92.7291 31.566 88.8744 28.9851 92.5746C28.941 92.6406 28.8969 92.7066 28.8528 92.7726C25.235 95.1299 22.4335 97.6184 20.0952 101.627C17.382 106.275 16.632 112.024 16.3672 117.332C16.2128 120.438 15.7938 123.94 17.4261 126.737C18.9482 129.335 21.6835 130.415 24.5071 130.877C30.066 131.78 37.2352 132.067 41.3603 127.398C44.4265 123.94 44.6912 118.675 45.3088 114.292C45.772 111.032 46.1912 107.772 46.7427 104.535C46.1471 100.262 43.4558 97.1338 39.5734 94.5567Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_3",
    id: "teeth_3",
  },
  {
    type: "path",
    d: "M24.2644 124.645C28.7423 122.355 22.1908 118.809 21.7496 115.946C21.3526 113.324 21.4849 110.637 20.9334 108.038C20.8672 107.686 19.8084 103.941 19.4995 104.338C18.8378 105.175 18.5069 106.342 18.2202 107.355C17.426 110.152 17.0069 113.038 16.4775 115.88C16.4333 116.364 16.4113 116.871 16.3892 117.355C16.2348 120.461 15.8157 123.963 17.4481 126.76C18.4849 128.544 20.1172 129.602 21.9482 130.262C21.4849 127.971 21.6393 126.011 24.2864 124.668L24.2644 124.645Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_3",
    id: "teeth_3",
  },
  {
    type: "path",
    d: "M39.5737 94.5587C36.8163 92.7311 31.5663 88.8764 28.9853 92.5765C28.9412 92.6426 28.8971 92.7086 28.8529 92.7746C25.6985 94.8235 23.1617 96.9819 21.022 100.153C21.1102 100.11 21.1764 100.044 21.2425 99.9776C21.4632 99.8448 21.8161 99.9769 21.8602 100.242C22.6764 105.154 20.1396 111.717 24.6617 115.373C28.3677 118.369 34.5001 119.03 39.0001 118.259C41.2502 117.863 43.8973 117.421 44.1179 120.506C44.1399 120.857 44.1399 121.232 44.1179 121.584C44.7135 119.184 44.9341 116.629 45.2649 114.316C45.7282 111.056 46.1473 107.797 46.6988 104.559C46.1032 100.286 43.412 97.1582 39.5296 94.5812L39.5737 94.5587Z",
    fill: "#E6E5DC",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M33.7053 124.226C33.6832 124.007 33.7494 123.764 34.0141 123.698C35.7568 123.258 38.3597 121.496 40.4774 121.583C39.8156 121.364 39.1318 121.231 38.4259 121.143C37.6097 121.341 36.8156 121.672 35.9332 122.068C35.0729 122.465 34.2568 122.531 33.4626 122.465C33.0215 122.508 32.5803 122.531 32.1391 122.487C29.9773 122.266 28.4994 120.438 27.0876 118.742C27.0876 118.786 27.0876 118.852 27.0876 118.874C27.617 119.844 27.7494 120.923 28.2346 121.914C29.1832 123.852 27.3743 124.8 25.9405 125.659C25.389 125.989 24.7934 126.495 24.4404 127.09C24.4404 127.486 24.4625 127.883 24.5508 128.279C24.7272 128.147 24.9037 127.839 24.8375 127.707C24.4184 126.584 27.0655 126.143 27.6832 125.746C28.4552 125.24 29.0728 124.491 29.4699 123.654C29.5802 123.412 29.7126 123.103 29.8229 122.795C30.6611 123.698 31.72 124.205 33.0656 124.292C32.8009 124.734 32.6465 125.196 32.867 125.593C33.1097 126.01 33.7053 126.209 34.1024 126.429C34.2126 126.495 34.4553 126.584 34.6097 126.693C34.6759 126.737 34.7641 126.76 34.8303 126.803C34.9406 126.87 35.0288 126.936 35.1171 127.002C35.0509 126.605 34.8744 126.231 34.4332 125.725C34.0362 125.262 33.7714 124.866 33.6832 124.249L33.7053 124.226Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_3",
    id: "teeth_3",
  },
  {
    type: "path",
    d: "M45.4416 79.9743C42.9049 78.0582 38.0519 74.0495 35.5371 77.6621C35.493 77.7281 35.4489 77.7942 35.4047 77.8602C31.9415 80.1064 29.2282 82.5071 26.934 86.4279C24.2649 90.9871 23.3826 96.7144 22.9855 102.022C22.8531 103.894 22.5443 107.155 22.809 110.128C23.6914 112 24.8164 113.762 26.5591 114.709C28.6768 115.876 31.0812 116.031 33.3974 116.119C35.515 116.207 37.6327 116.494 39.7504 116.56C39.8386 116.56 39.9048 116.56 39.993 116.537C41.3607 116.295 42.8607 115.854 44.2725 115.193C45.2652 114.268 46.1475 113.19 46.8975 111.978C49.0594 108.388 49.5888 104.049 50.2505 99.8856C50.7579 96.6484 51.2653 93.4103 51.8609 90.1723C51.4197 85.8997 48.9711 82.6835 45.3975 79.9743H45.4416Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_4",
    id: "teeth_4",
  },
  {
    type: "path",
    d: "M45.4416 79.9743C42.9049 78.0582 38.0519 74.0495 35.5371 77.6621C35.493 77.7281 35.4489 77.7942 35.4047 77.8602C31.9415 80.1064 29.2282 82.5071 26.934 86.4279C24.2649 90.9871 23.3826 96.7144 22.9855 102.022C22.8531 103.894 22.5443 107.155 22.809 110.128C23.6914 112 24.8164 113.762 26.5591 114.709C28.6768 115.876 31.0812 116.031 33.3974 116.119C35.515 116.207 37.6327 116.494 39.7504 116.56C39.8386 116.56 39.9048 116.56 39.993 116.537C41.3607 116.295 42.8607 115.854 44.2725 115.193C45.2652 114.268 46.1475 113.19 46.8975 111.978C49.0594 108.388 49.5888 104.049 50.2505 99.8856C50.7579 96.6484 51.2653 93.4103 51.8609 90.1723C51.4197 85.8997 48.9711 82.6835 45.3975 79.9743H45.4416Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_4",
    id: "teeth_4",
  },
  {
    type: "path",
    d: "M45.4415 79.9743C42.9047 78.0582 38.0518 74.0495 35.537 77.6621C35.4928 77.7281 35.4487 77.7942 35.4046 77.8602C32.4928 79.732 30.1325 81.7584 28.081 84.6663C27.1766 87.7055 26.2942 90.8333 26.9119 93.8507C27.6398 97.4631 31.5222 99.5113 30.2869 103.52C29.6693 105.503 28.8972 107.375 28.4119 109.401C28.081 110.789 27.5957 112.022 26.3384 112.793C25.4559 113.343 24.5515 112.727 23.7354 111.846C24.4633 113.035 25.3898 114.07 26.581 114.731C28.6987 115.899 31.1031 116.053 33.4193 116.141C35.537 116.229 37.6547 116.515 39.7723 116.581C39.8606 116.581 39.9267 116.581 40.015 116.56C41.3827 116.317 42.8827 115.876 44.2945 115.216C45.2871 114.291 46.1695 113.211 46.9195 112C49.0813 108.41 49.6107 104.07 50.2724 99.9082C50.7798 96.6701 51.2872 93.4321 51.8828 90.1941C51.4416 85.9215 48.9931 82.706 45.4195 79.9969L45.4415 79.9743Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_4",
    id: "teeth_4",
  },
  {
    type: "path",
    d: "M28.9194 94.7527C30.1989 98.0567 33.3754 99.576 36.5078 100.59C39.2651 101.492 46.9858 103.541 50.0961 101.118C50.1623 100.7 50.2285 100.281 50.2947 99.8626C50.802 96.6245 51.3094 93.3873 51.905 90.1493C51.4638 85.8759 49.0153 82.6604 45.4417 79.9513C42.9049 78.0352 38.0519 74.0262 35.5372 77.6383C35.493 77.7043 35.4489 77.7703 35.4048 77.8364C32.89 79.4666 30.7944 81.1847 28.9415 83.4976C28.39 87.2638 27.5738 91.2281 28.9194 94.7302V94.7527Z",
    fill: "#DBD8C6",
    opacity: 1.0,
    class: "teeth_4",
    id: "teeth_4",
  },
  {
    type: "path",
    d: "M38.2718 108.232C38.1173 107.946 38.3159 107.594 38.6467 107.594C40.5439 107.594 42.1542 106.712 43.8748 106.096C43.8307 106.096 43.7865 106.096 43.7645 106.096C42.088 106.58 39.9924 106.999 38.5365 106.25C38.5144 106.25 38.4924 106.228 38.4703 106.206C38.2718 106.118 38.0732 106.008 37.8967 105.853C36.8379 105.171 35.9335 104.29 35.0512 103.408C35.5805 104.444 35.9115 105.501 35.6246 106.536C35.3379 107.66 34.7864 108.232 33.8599 108.915C32.3158 110.061 31.4555 111.426 31.3452 113.122L31.3673 113.078C32.0511 110.831 33.4628 110.28 35.1173 109.003C35.757 108.496 36.0879 107.769 36.3305 107.021C36.3305 107.021 36.3747 107.043 36.3747 107.065C36.2864 107.241 36.2203 107.439 36.2644 107.55C36.4188 108.188 36.6835 108.628 37.1467 109.091C37.4115 109.355 37.7423 109.553 37.9188 109.906C37.985 110.038 38.0291 110.567 38.0952 110.721C38.1836 110.986 38.5144 111.205 38.735 111.36C39.1541 111.668 39.3747 112.219 39.838 112.483C39.8821 112.483 39.9262 112.483 39.9483 112.483C39.4409 111.052 38.9997 109.576 38.2497 108.232H38.2718Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_4",
    id: "teeth_4",
  },
  {
    type: "path",
    d: "M47.14 97.6845C48.618 96.7159 49.9416 95.5703 50.846 94.0503C53.3827 89.7552 55.6328 84.2928 55.6548 79.2489C55.6548 74.0951 54.8607 67.4873 53.8019 62.3993C53.2504 59.7562 51.2871 56.959 47.8459 56.959C43.0812 59.9104 37.0369 64.9543 33.9046 74.2933C32.6692 77.9495 30.6178 82.8613 30.6398 86.7595C30.6398 90.9226 33.1766 95.2177 37.1252 96.6056C40.1914 97.6845 43.8091 98.2577 47.14 97.707V97.6845Z",
    fill: "#F3F1E6",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M47.2601 97.6846C48.7381 96.7161 50.0617 95.5704 50.9661 94.0505C53.5029 89.7554 55.7529 84.2929 55.775 79.249C55.775 74.0952 54.9808 67.4874 53.922 62.3994C53.3705 59.7564 51.4072 56.9591 47.966 56.9591C43.2013 59.9105 37.1571 64.9545 34.0247 74.2934C32.7893 77.9496 30.7379 82.8614 30.7599 86.7597C30.7599 90.9227 33.2967 95.2178 37.2453 96.6058C40.3115 97.6846 43.9292 98.2578 47.2601 97.7071V97.6846Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_5",
    id: "teeth_5",
  },
  {
    type: "path",
    d: "M49.0907 57.9935C49.7083 59.8658 49.2892 62.2666 49.0245 64.1608C48.5391 67.6629 47.5024 71.1871 47.3039 74.7332C47.1494 77.3323 48.2965 79.006 49.7304 81.0324C51.0318 82.905 51.8259 84.6891 51.5833 87.0013C51.451 88.3015 50.9436 89.6009 51.0318 90.9221C51.0759 91.7368 51.2304 92.5081 51.4289 93.2793C53.7892 89.1162 55.7525 84.0064 55.7745 79.2709C55.7745 74.1165 54.9804 67.5087 53.9216 62.4208C53.3701 59.7777 51.4069 56.9804 47.9656 56.9804C47.8333 57.0685 47.6789 57.1566 47.5245 57.2667C48.1862 57.1786 48.848 57.2667 49.0907 58.0156V57.9935Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_5",
    id: "teeth_5",
  },
  {
    type: "path",
    d: "M40.1565 64.6904C38.811 66.4305 37.8403 68.589 36.8256 70.5273C35.0609 73.9413 33.1638 77.4653 32.6785 81.32C32.2594 84.7118 31.5755 90.8127 35.9212 92.0244C40.6639 93.3463 43.5537 86.6722 44.1271 83.0823C45.164 76.6287 43.5978 68.8093 45.2301 64.6685C46.8846 60.5276 44.9654 58.4131 40.1565 64.6685V64.6904Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_5",
    id: "teeth_5",
  },
  {
    type: "path",
    d: "M71.2505 55.3281C72.1991 58.8081 71.4932 62.927 71.6256 66.4731C71.7138 69.3585 72.0006 72.1778 72.53 74.9528C78.508 66.4731 74.2287 57.3544 74.2287 57.3544C74.2287 57.3544 72.1991 53.3017 68.8682 51.1211C70.0814 52.6629 71.0079 54.3589 71.2505 55.3061V55.3281Z",
    fill: "#C4C4BD",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M74.2946 54.4044C74.2946 54.4044 67.9856 40.5501 59.4267 48.0389C50.8457 55.5277 46.2133 73.6549 51.0442 79.2717C55.8751 84.9098 65.1841 84.6899 72.0886 75.0209C78.9933 65.3292 74.2946 54.4044 74.2946 54.4044Z",
    fill: "#E8E4CF",
    opacity: 1.0,
    class: "teeth_6",
    id: "teeth_6",
  },
  {
    type: "path",
    d: "M59.096 52.7969C59.096 52.7969 56.2283 53.1714 53.3165 59.4046C50.4047 65.638 48.9268 80.5715 55.721 79.1176C62.4931 77.6644 65.1181 53.2154 59.096 52.7969Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_6",
    id: "teeth_6",
  },
  {
    type: "path",
    d: "M95.1623 39.2271C94.0813 37.8835 92.9124 36.606 91.6985 35.3726C88.3014 33.7647 83.2718 33.5224 77.6473 40.2403C67.3234 52.5747 75.1325 72.464 76.2571 71.8473C77.36 71.2526 94.2358 74.138 97.9855 65.2396C100.301 59.7111 99.0883 50.9889 97.8309 45.152C96.9044 43.1917 96.0004 41.2314 95.1623 39.2491V39.2271Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_7",
    id: "teeth_7",
  },
  {
    type: "path",
    d: "M95.1625 39.2269C94.0822 37.8833 92.9351 36.6058 91.7212 35.3944C88.5889 33.9186 84.089 33.5882 78.9934 38.7644C80.6919 37.7731 82.545 37.1344 84.155 37.0243C89.6258 36.6719 92.6702 40.1299 92.5599 45.4382C92.4714 49.579 91.8315 53.7199 92.0303 57.8607C92.1631 60.3497 92.692 62.8605 92.692 65.3715C92.692 68.1468 91.7437 70.041 89.9349 71.0542C93.4422 70.2172 96.5962 68.5432 97.9864 65.2614C100.302 59.7329 99.0893 51.0107 97.8319 45.1739C96.9053 43.2136 96.0013 41.2533 95.1625 39.2709V39.2269Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_7",
    id: "teeth_7",
  },
  {
    type: "path",
    d: "M78.5522 42.3327C78.5522 42.3327 76.2137 43.6543 75.0223 50.9008C73.8309 58.1473 76.2797 69.3144 77.096 70.0853C77.9122 70.8561 84.8384 71.0764 85.5444 64.0282C86.2286 56.9799 84.6846 38.9188 78.5522 42.3107V42.3327Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_7",
    id: "teeth_7",
  },
  {
    type: "path",
    d: "M226.436 122.264C229.811 120.546 236.318 116.869 238.481 121.736C238.524 121.824 238.547 121.912 238.591 122C242.142 125.436 244.789 128.917 246.62 134.093C248.738 140.106 248.517 147.11 247.811 153.519C247.569 155.788 247.194 159.73 246.245 163.188C244.811 165.215 243.113 167.065 240.863 167.814C238.15 168.717 235.304 168.387 232.569 167.968C230.076 167.594 227.561 167.462 225.069 167.087C224.98 167.043 224.892 167.021 224.804 166.999C223.282 166.426 221.605 165.546 220.105 164.444C219.157 163.122 218.341 161.647 217.767 160.039C216.025 155.282 216.355 149.995 216.487 144.907C216.598 140.942 216.708 136.978 216.708 132.991C218.142 127.992 221.693 124.709 226.458 122.287L226.436 122.264Z",
    fill: "white",
    opacity: 0.8,
    class: "teeth_16",
    id: "teeth_16",
  },
  {
    type: "path",
    d: "M216.465 144.864C216.575 140.899 216.686 136.934 216.686 132.948C218.12 127.948 221.671 124.666 226.436 122.243C229.811 120.525 236.319 116.847 238.48 121.715C238.524 121.803 238.547 121.891 238.59 121.979C242.142 125.415 244.79 128.895 246.62 134.071C247.304 135.988 247.723 138.014 247.988 140.062C247.084 142.419 245.606 144.533 243.708 146.097C239.584 149.49 234.421 148.982 229.48 149.864C229.215 149.907 229.105 150.26 229.238 150.502C231.245 154.137 236.297 155.612 240.113 155.855C243.598 156.075 245.87 154.599 247.745 152.286C247.745 154.092 247.481 155.899 246.62 157.441C245.208 159.929 242.892 160.547 240.929 162.308C240.797 162.418 240.753 162.682 240.863 162.837C241.635 163.96 242.892 164.885 243.929 165.942C243.024 166.758 242.032 167.418 240.907 167.792C238.193 168.696 235.348 168.366 232.612 167.947C230.12 167.573 227.605 167.44 225.112 167.066C225.025 167.022 224.936 167 224.847 166.978C223.326 166.405 221.649 165.524 220.15 164.423C219.2 163.101 218.384 161.625 217.811 160.018C216.068 155.26 216.399 149.973 216.532 144.886L216.465 144.864Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_16",
    id: "teeth_16",
  },
  {
    type: "path",
    d: "M216.466 144.864C216.576 140.899 216.686 136.934 216.686 132.948C218.12 127.948 221.672 124.666 226.437 122.243C229.811 120.525 236.319 116.847 238.481 121.715C238.524 121.803 238.547 121.891 238.591 121.979C242.099 125.371 244.701 128.807 246.532 133.873C246.598 136.472 246.355 139.115 245.473 141.494C243.709 146.23 239.738 147.793 235.216 148.784C230.826 149.732 226.657 148.784 222.355 148.014C220.591 147.705 218.473 147.551 217.834 149.643C217.789 149.82 217.855 150.062 218.032 150.128C219.863 150.943 221.848 150.899 223.745 151.516C226.106 152.286 228.289 153.432 230.363 154.819C233.098 156.648 235.966 158.013 239.12 158.278C236.12 158.652 232.877 157.132 230.164 156.075C226.922 154.797 223.481 153.388 219.951 154.07C219.664 154.136 219.576 154.467 219.708 154.71C220.216 155.701 220.767 156.846 221.914 157.176C222.73 157.419 225.4 157.309 225.4 158.498C225.4 160.921 225.355 163.388 227.076 165.304C228.047 166.383 229.215 167.154 230.517 167.726C228.708 167.528 226.878 167.374 225.069 167.088C224.98 167.044 224.892 167.022 224.804 167C223.282 166.427 221.605 165.546 220.105 164.445C219.157 163.123 218.341 161.647 217.767 160.039C216.025 155.282 216.356 149.996 216.488 144.908L216.466 144.864Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_16",
    id: "teeth_16",
  },
  {
    type: "path",
    d: "M219.972 152C220.48 151.912 220.965 151.824 221.472 151.736C224.495 152.221 227.34 153.454 230.208 154.754C230.208 154.754 230.23 154.754 230.252 154.776C231.2 155.304 232.303 155.789 233.473 156.208C234.928 157.044 236.406 157.794 238.017 158.124C239.208 158.366 240.509 158.564 241.678 158.168C242.583 157.86 243.708 157.133 244.789 156.89C244.26 158.145 242.12 159.467 241.083 159.754C239.649 160.15 238.149 159.446 236.847 158.938C236.362 158.74 235.899 158.542 235.414 158.322C235.679 158.917 235.855 159.555 235.988 160.172C235.899 159.776 236.142 160.305 236.23 160.392C236.517 160.723 236.87 161.031 237.201 161.317C237.576 161.626 238.391 162.375 239.031 162.595C237.774 162.375 236.583 161.978 235.392 161.516C234.951 161.053 234.576 160.546 234.245 160.018C233.781 159.269 233.847 158.322 233.406 157.573C233.363 157.485 233.318 157.397 233.274 157.286C232.767 157.022 232.259 156.78 231.752 156.516C230.781 156.714 229.745 156.736 228.708 156.846C227.869 156.736 227.01 156.736 226.149 156.758C224.605 156.758 223.171 156.406 221.759 155.987C223.348 155.547 225.223 155.547 226.855 155.393C227.759 155.304 228.598 155.283 229.414 155.349C226.414 153.85 223.392 152.507 220.017 152.045C220.017 152.045 219.995 152.045 219.972 152.045V152Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_16",
    id: "teeth_16",
  },
  {
    type: "path",
    d: "M219.289 103.454C222.355 101.229 228.245 96.5599 231.112 101.031C231.157 101.119 231.201 101.208 231.245 101.274C235.281 104.115 238.392 107.132 240.995 111.956C243.995 117.573 244.833 124.532 245.098 130.942C245.186 133.211 245.429 137.175 245.01 140.744C243.907 142.968 242.495 145.06 240.399 146.162C237.863 147.484 234.995 147.594 232.238 147.616C229.723 147.616 227.208 147.902 224.693 147.924C224.605 147.924 224.494 147.902 224.407 147.88C222.796 147.55 221.031 146.955 219.377 146.096C218.23 144.928 217.216 143.607 216.399 142.109C213.951 137.682 213.487 132.418 212.848 127.374C212.34 123.431 211.877 119.489 211.281 115.568C211.965 110.414 214.965 106.604 219.311 103.454H219.289Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_15",
    id: "teeth_15",
  },
  {
    type: "path",
    d: "M219.289 103.454C222.355 101.229 228.245 96.5599 231.112 101.031C231.157 101.119 231.201 101.208 231.245 101.274C235.281 104.115 238.392 107.132 240.995 111.956C243.995 117.573 244.833 124.532 245.098 130.942C245.186 133.211 245.429 137.175 245.01 140.744C243.907 142.968 242.495 145.06 240.399 146.162C237.863 147.484 234.995 147.594 232.238 147.616C229.723 147.616 227.208 147.902 224.693 147.924C224.605 147.924 224.494 147.902 224.407 147.88C222.796 147.55 221.031 146.955 219.377 146.096C218.23 144.928 217.216 143.607 216.399 142.109C213.951 137.682 213.487 132.418 212.848 127.374C212.34 123.431 211.877 119.489 211.281 115.568C211.965 110.414 214.965 106.604 219.311 103.454H219.289Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_15",
    id: "teeth_15",
  },
  {
    type: "path",
    d: "M233.518 146.316C232.193 145.039 231.885 143.189 233.628 142.109C234.333 141.669 235.039 141.317 235.811 141.052C238.348 140.149 239.782 139.18 240.422 136.427C240.51 136.097 240.113 135.721 239.782 135.942C239.12 136.405 238.26 137.088 237.466 137.22C235.811 137.462 234.069 136.471 235.789 135.391C236.584 134.885 237.444 134.488 238.194 133.916C239.429 132.991 240.73 131.977 241.26 130.458C242.606 126.603 240.995 121.823 242.87 118.211C243.157 118.453 243.4 118.762 243.642 119.07C244.591 122.947 244.966 127.043 245.12 130.964C245.208 133.233 245.452 137.197 245.032 140.766C243.929 142.991 242.517 145.083 240.422 146.184C238.944 146.955 237.378 147.307 235.768 147.484C234.929 147.263 234.112 146.911 233.539 146.338L233.518 146.316Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_15",
    id: "teeth_15",
  },
  {
    type: "path",
    d: "M219.289 103.454C222.356 101.229 228.245 96.5599 231.113 101.031C231.157 101.119 231.201 101.208 231.245 101.274C235.282 104.115 238.392 107.132 240.995 111.956C241.238 112.397 241.458 112.859 241.657 113.322C241.481 113.167 241.304 113.013 241.105 112.881C240.841 112.683 240.466 112.947 240.466 113.256C240.532 118.674 243.267 126.779 237.885 130.502C235.128 132.418 231.532 132.836 228.267 132.903C226.877 132.925 225.51 132.946 224.142 132.661C223.194 132.462 222.179 132.132 221.208 132.132C219.245 132.132 219.223 133.673 219.576 135.259C220.039 137.33 219.179 138.519 218.363 140.259C218.098 140.854 217.965 141.492 217.943 142.153C217.943 142.66 217.943 143.585 218.032 144.643C217.414 143.871 216.862 143.034 216.355 142.153C213.906 137.726 213.443 132.462 212.804 127.418C212.296 123.475 211.833 119.533 211.238 115.612C211.921 110.458 214.921 106.648 219.267 103.498L219.289 103.454Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_15",
    id: "teeth_15",
  },
  {
    type: "path",
    d: "M219.025 136.866C218.848 136.69 218.694 136.513 218.539 136.337C220.039 136.645 221.672 136.624 223.105 136.293C223.26 136.249 223.414 136.205 223.569 136.161C224.672 135.919 225.775 135.588 226.9 135.236C227.297 135.236 227.694 135.302 228.135 135.478C229.481 136.007 231.311 137.174 233.032 137.703C235.348 138.804 237.532 138.122 239.341 136.645C237.378 139.135 235.745 139.707 232.789 138.496C232.083 138.077 231.4 137.637 230.694 137.218C230.23 138.584 228.907 139.531 228.686 141.029C228.466 142.592 229.525 143.826 229.767 145.192C229.767 145.214 229.723 145.235 229.723 145.258C229.503 145.125 229.304 144.993 229.084 144.839C228.665 143.738 227.937 142.901 227.473 141.865C227.319 142.108 227.142 142.35 227.01 142.526C226.502 143.166 225.686 143.782 224.958 144.112C224.231 144.442 223.282 144.112 222.51 143.892C222.73 143.826 222.973 143.76 223.194 143.672C224.981 143.166 226.657 142.042 226.988 140.434C227.032 140.412 227.054 140.39 227.098 140.368C227.098 140.214 227.098 140.038 227.098 139.862C227.164 138.782 227.826 138.122 228.576 137.527C228.576 137.483 228.576 137.438 228.576 137.417C228.576 137.395 228.576 137.35 228.598 137.329C227.87 137.152 227.076 136.888 227.385 136.866C225.819 137.02 224.473 137.725 222.841 137.747C221.429 137.747 220.172 137.461 219.046 136.866H219.025Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_15",
    id: "teeth_15",
  },
  {
    type: "path",
    d: "M214.052 88.4538C217.118 86.2293 223.008 81.5599 225.875 86.0313C225.919 86.1191 225.963 86.2076 226.008 86.2736C230.044 89.1148 233.155 92.1322 235.758 96.9562C238.758 102.573 239.596 109.532 239.861 115.942C239.949 118.211 240.192 122.175 239.773 125.744C238.67 127.968 237.258 130.06 235.162 131.162C232.625 132.484 229.758 132.594 227 132.616C224.486 132.616 221.971 132.902 219.456 132.924C219.368 132.924 219.258 132.902 219.169 132.88C217.559 132.55 215.794 131.955 214.14 131.096C212.993 129.928 211.978 128.607 211.162 127.109C208.713 122.682 208.25 117.418 207.61 112.374C207.103 108.431 206.64 104.489 206.044 100.568C206.728 95.4145 209.728 91.604 214.074 88.4538H214.052Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_14",
    id: "teeth_14",
  },
  {
    type: "path",
    d: "M228.302 131.316C226.979 130.039 226.67 128.189 228.413 127.109C229.119 126.669 229.824 126.317 230.596 126.052C233.133 125.149 234.567 124.18 235.207 121.427C235.295 121.097 234.898 120.721 234.567 120.942C233.905 121.405 233.045 122.088 232.251 122.22C230.596 122.462 228.854 121.471 230.574 120.391C231.369 119.885 232.229 119.488 232.979 118.916C234.214 117.991 235.516 116.977 236.045 115.458C237.391 111.603 235.78 106.823 237.655 103.211C237.942 103.453 238.185 103.762 238.427 104.07C239.376 107.947 239.751 112.043 239.905 115.964C239.994 118.233 240.236 122.197 239.817 125.766C238.714 127.991 237.302 130.083 235.207 131.184C233.729 131.955 232.163 132.307 230.552 132.484C229.714 132.263 228.92 131.911 228.324 131.338L228.302 131.316Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_14",
    id: "teeth_14",
  },
  {
    type: "path",
    d: "M214.052 88.4538C217.118 86.2293 223.008 81.5599 225.875 86.0313C225.92 86.1191 225.964 86.2076 226.008 86.2736C230.045 89.1148 233.155 92.1322 235.758 96.9562C236.001 97.3966 236.221 97.8588 236.42 98.3217C236.243 98.1671 236.067 98.0133 235.868 97.8813C235.603 97.6832 235.228 97.9473 235.228 98.2556C235.295 103.674 238.03 111.779 232.648 115.502C229.89 117.418 226.295 117.836 223.03 117.903C221.64 117.925 220.272 117.946 218.905 117.661C217.956 117.462 216.941 117.132 215.971 117.132C214.008 117.132 213.986 118.673 214.338 120.259C214.802 122.33 213.941 123.519 213.125 125.259C212.861 125.854 212.728 126.492 212.706 127.153C212.706 127.66 212.706 128.585 212.794 129.643C212.177 128.871 211.625 128.034 211.118 127.153C208.669 122.726 208.206 117.462 207.566 112.418C207.059 108.475 206.596 104.533 206 100.612C206.684 95.458 209.684 91.6475 214.03 88.4981L214.052 88.4538Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_14",
    id: "teeth_14",
  },
  {
    type: "path",
    d: "M213.787 121.868C213.611 121.692 213.456 121.515 213.302 121.339C214.802 121.647 216.434 121.625 217.868 121.295C218.022 121.251 218.177 121.207 218.331 121.163C219.434 120.921 220.537 120.59 221.662 120.238C222.059 120.238 222.456 120.304 222.897 120.48C224.243 121.009 226.074 122.176 227.795 122.705C230.111 123.806 232.295 123.124 234.104 121.647C232.14 124.137 230.508 124.709 227.552 123.498C226.846 123.079 226.162 122.639 225.456 122.22C224.993 123.586 223.67 124.533 223.471 126.031C223.25 127.594 224.309 128.828 224.552 130.194C224.552 130.216 224.508 130.237 224.508 130.26C224.287 130.127 224.089 129.995 223.868 129.841C223.449 128.74 222.721 127.903 222.258 126.867C222.103 127.11 221.927 127.352 221.795 127.528C221.287 128.168 220.471 128.784 219.743 129.114C219.015 129.444 218.067 129.114 217.294 128.894C217.515 128.828 217.758 128.762 217.978 128.674C219.765 128.168 221.442 127.044 221.772 125.436C221.817 125.414 221.839 125.392 221.883 125.37C221.883 125.216 221.883 125.04 221.883 124.864C221.949 123.784 222.611 123.124 223.361 122.529C223.361 122.484 223.361 122.44 223.361 122.418C223.361 122.397 223.361 122.352 223.383 122.331C222.655 122.154 221.861 121.89 222.169 121.868C220.603 122.022 219.258 122.727 217.625 122.749C216.214 122.749 214.956 122.463 213.831 121.868H213.787Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_14",
    id: "teeth_14",
  },
  {
    type: "path",
    d: "M210.929 79.9743C213.465 78.0582 218.319 74.0495 220.833 77.6621C220.878 77.7281 220.922 77.7942 220.966 77.8602C224.429 80.1064 227.142 82.5071 229.436 86.4279C232.106 90.9871 232.988 96.7144 233.385 102.022C233.518 103.894 233.826 107.155 233.539 110.128C232.657 112 231.532 113.762 229.79 114.709C227.672 115.876 225.267 116.031 222.951 116.119C220.833 116.207 218.716 116.494 216.598 116.56C216.51 116.56 216.444 116.56 216.355 116.537C214.988 116.295 213.488 115.854 212.076 115.193C211.083 114.268 210.201 113.19 209.451 111.978C207.289 108.388 206.76 104.049 206.098 99.8856C205.591 96.6484 205.083 93.4103 204.487 90.1723C204.929 85.8997 207.377 82.6835 210.951 79.9743H210.929Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_13",
    id: "teeth_13",
  },
  {
    type: "path",
    d: "M210.929 79.9743C213.465 78.0582 218.319 74.0495 220.833 77.6621C220.878 77.7281 220.922 77.7942 220.966 77.8602C224.429 80.1064 227.142 82.5071 229.436 86.4279C232.106 90.9871 232.988 96.7144 233.385 102.022C233.518 103.894 233.826 107.155 233.539 110.128C232.657 112 231.532 113.762 229.79 114.709C227.672 115.876 225.267 116.031 222.951 116.119C220.833 116.207 218.716 116.494 216.598 116.56C216.51 116.56 216.444 116.56 216.355 116.537C214.988 116.295 213.488 115.854 212.076 115.193C211.083 114.268 210.201 113.19 209.451 111.978C207.289 108.388 206.76 104.049 206.098 99.8856C205.591 96.6484 205.083 93.4103 204.487 90.1723C204.929 85.8997 207.377 82.6835 210.951 79.9743H210.929Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_13",
    id: "teeth_13",
  },
  {
    type: "path",
    d: "M210.929 79.9743C213.465 78.0582 218.319 74.0495 220.833 77.6621C220.878 77.7281 220.922 77.7942 220.966 77.8602C223.878 79.732 226.238 81.7584 228.289 84.6663C229.194 87.7055 230.076 90.8333 229.458 93.8507C228.73 97.4631 224.848 99.5113 226.084 103.52C226.701 105.503 227.473 107.375 227.958 109.401C228.289 110.789 228.775 112.022 230.032 112.793C230.914 113.343 231.819 112.727 232.635 111.846C231.907 113.035 230.98 114.07 229.79 114.731C227.672 115.899 225.267 116.053 222.951 116.141C220.833 116.229 218.716 116.515 216.598 116.581C216.51 116.581 216.444 116.581 216.355 116.56C214.988 116.317 213.488 115.876 212.076 115.216C211.083 114.291 210.201 113.211 209.451 112C207.289 108.41 206.76 104.07 206.098 99.9082C205.591 96.6701 205.083 93.4321 204.487 90.1941C204.929 85.9215 207.377 82.706 210.951 79.9969L210.929 79.9743Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_13",
    id: "teeth_13",
  },
  {
    type: "path",
    d: "M227.473 94.7527C226.194 98.0567 223.017 99.576 219.885 100.59C217.127 101.492 209.407 103.541 206.297 101.118C206.23 100.7 206.164 100.281 206.098 99.8626C205.591 96.6245 205.083 93.3873 204.487 90.1493C204.929 85.8759 207.377 82.6604 210.951 79.9513C213.488 78.0352 218.34 74.0262 220.855 77.6383C220.9 77.7043 220.944 77.7703 220.988 77.8364C223.503 79.4666 225.598 81.1847 227.451 83.4976C228.003 87.2638 228.819 91.2281 227.473 94.7302V94.7527Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_13",
    id: "teeth_13",
  },
  {
    type: "path",
    d: "M218.121 108.232C218.275 107.946 218.077 107.594 217.746 107.594C215.848 107.594 214.238 106.712 212.518 106.096C212.562 106.096 212.584 106.096 212.628 106.096C214.304 106.58 216.4 106.999 217.856 106.25C217.878 106.25 217.9 106.228 217.922 106.206C218.121 106.118 218.32 106.008 218.496 105.853C219.555 105.171 220.459 104.29 221.342 103.408C220.812 104.444 220.481 105.501 220.768 106.536C221.054 107.66 221.606 108.232 222.532 108.915C224.077 110.061 224.937 111.426 225.047 113.122L225.025 113.078C224.342 110.831 222.93 110.28 221.276 109.003C220.636 108.496 220.305 107.769 220.062 107.021C220.062 107.021 220.018 107.043 220.018 107.065C220.106 107.241 220.172 107.439 220.128 107.55C219.974 108.188 219.709 108.628 219.245 109.091C218.981 109.355 218.65 109.553 218.473 109.906C218.407 110.038 218.341 110.567 218.297 110.721C218.209 110.986 217.878 111.205 217.657 111.36C217.239 111.668 217.018 112.219 216.554 112.483C216.511 112.483 216.467 112.483 216.444 112.483C216.952 111.052 217.393 109.576 218.143 108.232H218.121Z",
    fill: "#E6E5DC",
    opacity: 1.0,
    class: "teeth_13",
    id: "teeth_13",
  },
  {
    type: "path",
    d: "M209.231 97.6845C207.753 96.7159 206.429 95.5703 205.525 94.0503C202.988 89.7552 200.738 84.2928 200.716 79.2489C200.716 74.0951 201.51 67.4873 202.569 62.3993C203.12 59.7562 205.084 56.959 208.525 56.959C213.29 59.9104 219.334 64.9543 222.466 74.2933C223.702 77.9495 225.753 82.8613 225.731 86.7595C225.731 90.9226 223.194 95.2177 219.246 96.6056C216.18 97.6845 212.561 98.2577 209.231 97.707V97.6845Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_12",
    id: "teeth_12",
  },
  {
    type: "path",
    d: "M209.231 97.6845C207.753 96.7159 206.429 95.5703 205.525 94.0503C202.988 89.7552 200.738 84.2928 200.716 79.2489C200.716 74.0951 201.51 67.4873 202.569 62.3993C203.12 59.7562 205.084 56.959 208.525 56.959C213.29 59.9104 219.334 64.9543 222.466 74.2933C223.702 77.9495 225.753 82.8613 225.731 86.7595C225.731 90.9226 223.194 95.2177 219.246 96.6056C216.18 97.6845 212.561 98.2577 209.231 97.707V97.6845Z",
    fill: "#F3F1E6",
    opacity: 1.0,
    class: "teeth_12",
    id: "teeth_12",
  },
  {
    type: "path",
    d: "M207.4 57.9935C206.782 59.8658 207.202 62.2666 207.466 64.1608C207.974 67.6629 208.988 71.1871 209.187 74.7332C209.341 77.3323 208.194 79.006 206.76 81.0324C205.459 82.905 204.664 84.6891 204.907 87.0013C205.039 88.3015 205.525 89.6009 205.459 90.9221C205.415 91.7368 205.26 92.5081 205.061 93.2793C202.701 89.1162 200.738 84.0064 200.716 79.2709C200.716 74.1165 201.51 67.5087 202.569 62.4208C203.12 59.7777 205.084 56.9804 208.525 56.9804C208.657 57.0685 208.812 57.1566 208.966 57.2667C208.304 57.1786 207.643 57.2667 207.4 58.0156V57.9935Z",
    fill: "#E8E4CF",
    opacity: 1.0,
    class: "teeth_12",
    id: "teeth_12",
  },
  {
    type: "path",
    d: "M216.333 64.6904C217.678 66.4305 218.671 68.589 219.664 70.5273C221.429 73.9413 223.325 77.4653 223.811 81.32C224.23 84.7118 224.914 90.8127 220.568 92.0244C215.825 93.3463 212.936 86.6722 212.362 83.0823C211.325 76.6287 212.892 68.8093 211.259 64.6685C209.605 60.5276 211.524 58.4131 216.333 64.6685V64.6904Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_12",
    id: "teeth_12",
  },
  {
    type: "path",
    d: "M182.098 54.4044C182.098 54.4044 188.406 40.5501 196.965 48.0389C205.524 55.5277 210.179 73.6549 205.347 79.2717C200.517 84.9098 191.208 84.6899 184.303 75.0209C177.399 65.3292 182.098 54.4044 182.098 54.4044Z",
    fill: "#E8E4CF",
    opacity: 1.0,
    class: "teeth_11",
    id: "teeth_11",
  },
  {
    type: "path",
    d: "M197.274 52.7969C197.274 52.7969 200.142 53.1714 203.054 59.4046C205.966 65.6159 207.443 80.5715 200.649 79.1176C193.877 77.6644 191.252 53.2154 197.274 52.7969Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_11",
    id: "teeth_11",
  },
  {
    type: "path",
    d: "M161.229 39.2271C162.31 37.8835 163.479 36.606 164.692 35.3726C168.089 33.7647 173.119 33.5224 178.744 40.2403C189.068 52.5747 181.259 72.464 180.134 71.8473C179.031 71.2526 162.156 74.138 158.406 65.2396C156.089 59.7111 157.302 50.9889 158.56 45.152C159.486 43.1917 160.391 41.2314 161.229 39.2491V39.2271Z",
    fill: "#E8E4CF",
    opacity: 1.0,
    class: "teeth_10",
    id: "teeth_10",
  },
  {
    type: "path",
    d: "M177.84 42.3327C177.84 42.3327 180.178 43.6542 181.369 50.9008C182.56 58.1473 180.112 69.3144 179.295 70.0853C178.479 70.8561 171.553 71.0764 170.847 64.0281C170.163 56.9799 171.707 38.9187 177.84 42.3107V42.3327Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_10",
    id: "teeth_10",
  },
  {
    type: "path",
    d: "M131.582 35.8571C131.582 35.8571 135.95 24.9323 148.104 29.4917C160.259 34.051 157.81 60.3719 157.81 60.3719C157.81 60.3719 158.119 66.8475 152.384 67.4201C146.648 67.9928 127.942 68.6977 128.074 64.4687C128.229 60.2398 127.567 40.9891 131.582 35.8571Z",
    fill: "#E8E4CF",
    opacity: 1.0,
    class: "teeth_9",
    id: "teeth_9",
  },
  {
    type: "path",
    d: "M134.471 37.5318C134.471 37.5318 138.133 29.25 148.17 32.642C158.207 36.034 156.045 55.9233 156.045 55.9233C156.045 55.9233 156.265 60.813 151.523 61.2756C146.78 61.7381 131.294 62.3549 131.427 59.1611C131.559 55.9673 131.118 41.4303 134.471 37.5318Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_9",
    id: "teeth_9",
  },
  {
    type: "path",
    d: "M143.295 47.3596V54.3618M139.794 50.8607H146.796",
    fill: "#000000",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M124.788 35.8571C124.788 35.8571 120.42 24.9323 108.265 29.4917C96.1106 34.051 98.5594 60.3719 98.5594 60.3719C98.5594 60.3719 98.2503 66.8475 103.986 67.4201C109.721 67.9928 128.427 68.6977 128.295 64.4687C128.141 60.2398 128.802 40.9891 124.788 35.8571Z",
    fill: "#E8E4CF",
    opacity: 1.0,
    class: "teeth_8",
    id: "teeth_8",
  },
  {
    type: "path",
    d: "M121.832 37.5968C121.832 37.5968 118.258 29.3591 108.177 32.8612C98.0964 36.3633 100.016 56.2526 100.016 56.2526C100.016 56.2526 99.7282 61.1424 104.471 61.5609C109.214 61.9573 124.699 62.3978 124.589 59.2041C124.501 56.0103 125.119 41.4733 121.832 37.5968Z",
    fill: "white",
    opacity: 1.0,
    class: "teeth_8",
    id: "teeth_8",
  },
  {
    type: "path",
    d: "M202.858 173.961L200.751 177.679V179.903H199.509V177.679L197.402 173.961H198.726L199.68 175.743L200.13 176.671L200.589 175.743L201.544 173.961H202.858ZM204.787 175.311C205.243 175.311 205.642 175.404 205.984 175.59C206.332 175.776 206.603 176.044 206.795 176.392C206.993 176.74 207.092 177.16 207.092 177.652C207.092 178.138 206.993 178.558 206.795 178.912C206.603 179.261 206.332 179.528 205.984 179.714C205.642 179.9 205.243 179.993 204.787 179.993C204.337 179.993 203.938 179.9 203.59 179.714C203.241 179.528 202.968 179.261 202.77 178.912C202.578 178.558 202.482 178.138 202.482 177.652C202.482 177.16 202.578 176.74 202.77 176.392C202.968 176.044 203.241 175.776 203.59 175.59C203.938 175.404 204.337 175.311 204.787 175.311ZM204.787 176.23C204.559 176.23 204.364 176.284 204.202 176.392C204.046 176.494 203.926 176.65 203.842 176.86C203.758 177.07 203.716 177.334 203.716 177.652C203.716 177.97 203.758 178.234 203.842 178.444C203.926 178.654 204.046 178.813 204.202 178.921C204.364 179.024 204.559 179.075 204.787 179.075C205.009 179.075 205.198 179.024 205.354 178.921C205.516 178.813 205.639 178.654 205.723 178.444C205.807 178.234 205.849 177.97 205.849 177.652C205.849 177.334 205.807 177.07 205.723 176.86C205.639 176.65 205.516 176.494 205.354 176.392C205.198 176.284 205.009 176.23 204.787 176.23ZM209.69 179.993C209.39 179.993 209.12 179.939 208.88 179.831C208.64 179.723 208.448 179.552 208.304 179.318C208.166 179.078 208.097 178.768 208.097 178.39V175.401H209.33V178.093C209.33 178.441 209.402 178.684 209.546 178.822C209.69 178.954 209.898 179.021 210.168 179.021C210.294 179.021 210.417 179 210.537 178.958C210.657 178.909 210.762 178.837 210.852 178.741C210.948 178.645 211.023 178.522 211.077 178.372C211.131 178.216 211.158 178.033 211.158 177.823V175.401H212.391V179.903H211.293L211.248 179.12C211.098 179.42 210.891 179.642 210.627 179.786C210.369 179.924 210.057 179.993 209.69 179.993ZM213.689 179.903V175.401H214.761L214.842 176.284C214.962 175.972 215.136 175.731 215.364 175.563C215.598 175.395 215.889 175.311 216.237 175.311C216.339 175.311 216.432 175.32 216.516 175.338C216.6 175.356 216.669 175.38 216.723 175.41L216.579 176.446C216.519 176.422 216.444 176.404 216.354 176.392C216.27 176.38 216.159 176.374 216.021 176.374C215.841 176.374 215.667 176.419 215.499 176.509C215.331 176.593 215.193 176.725 215.085 176.905C214.977 177.079 214.923 177.301 214.923 177.571V179.903H213.689ZM221.288 173.43V178.516C221.288 178.726 221.324 178.873 221.396 178.958C221.468 179.042 221.588 179.084 221.756 179.084C221.858 179.084 221.942 179.078 222.008 179.066C222.074 179.048 222.158 179.024 222.26 178.994L222.152 179.804C222.05 179.864 221.921 179.909 221.765 179.939C221.615 179.975 221.465 179.993 221.315 179.993C220.877 179.993 220.555 179.888 220.351 179.678C220.153 179.462 220.054 179.12 220.054 178.651V173.43H221.288ZM225.036 179.993C224.562 179.993 224.148 179.9 223.793 179.714C223.445 179.528 223.175 179.261 222.983 178.912C222.791 178.564 222.695 178.144 222.695 177.652C222.695 177.16 222.791 176.74 222.983 176.392C223.175 176.044 223.442 175.776 223.784 175.59C224.133 175.404 224.529 175.311 224.973 175.311C225.429 175.311 225.816 175.404 226.134 175.59C226.452 175.77 226.695 176.02 226.863 176.338C227.031 176.65 227.115 177.007 227.115 177.409C227.115 177.529 227.113 177.643 227.106 177.751C227.1 177.859 227.091 177.955 227.079 178.039H223.487V177.184H226.539L225.945 177.4C225.945 177.022 225.858 176.731 225.684 176.527C225.516 176.323 225.276 176.221 224.964 176.221C224.736 176.221 224.538 176.275 224.37 176.383C224.208 176.491 224.085 176.653 224.001 176.869C223.916 177.079 223.874 177.346 223.874 177.67C223.874 177.988 223.919 178.252 224.01 178.462C224.106 178.666 224.238 178.819 224.406 178.921C224.58 179.024 224.787 179.075 225.027 179.075C225.291 179.075 225.504 179.024 225.666 178.921C225.828 178.819 225.954 178.678 226.044 178.498L227.025 178.876C226.929 179.111 226.782 179.312 226.584 179.48C226.392 179.648 226.161 179.777 225.891 179.867C225.627 179.951 225.342 179.993 225.036 179.993ZM230.142 173.34C230.352 173.34 230.541 173.364 230.709 173.412C230.883 173.454 231.012 173.508 231.096 173.574L230.925 174.393C230.859 174.351 230.784 174.318 230.7 174.294C230.616 174.27 230.517 174.258 230.403 174.258C230.169 174.258 229.983 174.312 229.845 174.42C229.707 174.522 229.638 174.699 229.638 174.951V175.572L229.692 175.816V179.903H228.458V174.861C228.458 174.609 228.5 174.387 228.584 174.195C228.668 174.003 228.786 173.844 228.936 173.718C229.086 173.592 229.263 173.499 229.467 173.439C229.677 173.373 229.902 173.34 230.142 173.34ZM231.06 175.401V176.32H227.675V175.401H231.06ZM233.033 174.024V178.435C233.033 178.651 233.087 178.81 233.195 178.912C233.309 179.009 233.463 179.057 233.655 179.057C233.805 179.057 233.937 179.036 234.051 178.994C234.165 178.945 234.267 178.882 234.357 178.804L234.555 179.624C234.411 179.738 234.231 179.828 234.015 179.894C233.799 179.96 233.571 179.993 233.33 179.993C233.03 179.993 232.763 179.948 232.529 179.858C232.301 179.768 232.121 179.624 231.989 179.426C231.863 179.228 231.8 178.964 231.8 178.633V174.366L233.033 174.024ZM234.474 175.401V176.32H230.972V175.401H234.474ZM239.861 179.993C239.404 179.993 238.987 179.912 238.609 179.75C238.237 179.588 237.934 179.36 237.7 179.066L238.411 178.345C238.555 178.561 238.747 178.738 238.987 178.876C239.227 179.015 239.512 179.084 239.843 179.084C240.077 179.084 240.263 179.051 240.401 178.985C240.545 178.912 240.617 178.801 240.617 178.651C240.617 178.555 240.584 178.474 240.518 178.408C240.452 178.336 240.32 178.279 240.122 178.237L239.329 178.075C238.807 177.967 238.435 177.805 238.213 177.589C237.997 177.367 237.889 177.082 237.889 176.734C237.889 176.488 237.961 176.257 238.105 176.041C238.255 175.825 238.477 175.65 238.771 175.518C239.065 175.38 239.431 175.311 239.87 175.311C240.32 175.311 240.71 175.383 241.04 175.527C241.376 175.665 241.64 175.873 241.832 176.149L241.094 176.869C240.962 176.659 240.788 176.5 240.572 176.392C240.362 176.278 240.14 176.221 239.906 176.221C239.737 176.221 239.593 176.239 239.473 176.275C239.353 176.311 239.263 176.362 239.203 176.428C239.143 176.488 239.113 176.566 239.113 176.662C239.113 176.758 239.155 176.842 239.239 176.914C239.323 176.98 239.476 177.037 239.698 177.085L240.617 177.274C241.061 177.364 241.379 177.517 241.571 177.733C241.763 177.943 241.859 178.198 241.859 178.498C241.859 178.786 241.781 179.045 241.625 179.273C241.475 179.495 241.25 179.672 240.95 179.804C240.656 179.93 240.293 179.993 239.861 179.993ZM243.464 174.753C243.206 174.753 243.014 174.699 242.888 174.591C242.762 174.477 242.699 174.312 242.699 174.096C242.699 173.874 242.762 173.709 242.888 173.601C243.014 173.487 243.206 173.43 243.464 173.43C243.722 173.43 243.914 173.487 244.04 173.601C244.166 173.709 244.229 173.874 244.229 174.096C244.229 174.312 244.166 174.477 244.04 174.591C243.914 174.699 243.722 174.753 243.464 174.753ZM244.076 175.401V179.903H242.843V175.401H244.076ZM247.085 179.993C246.713 179.993 246.38 179.9 246.086 179.714C245.798 179.528 245.57 179.261 245.402 178.912C245.24 178.564 245.159 178.147 245.159 177.661C245.159 177.163 245.246 176.74 245.42 176.392C245.594 176.038 245.828 175.77 246.122 175.59C246.422 175.404 246.758 175.311 247.13 175.311C247.526 175.311 247.854 175.425 248.112 175.653C248.37 175.882 248.538 176.176 248.616 176.536L248.499 176.68V173.43H249.732V179.903H248.625L248.544 178.534L248.697 178.606C248.655 178.888 248.559 179.135 248.409 179.345C248.259 179.549 248.07 179.708 247.842 179.822C247.613 179.936 247.361 179.993 247.085 179.993ZM247.445 179.048C247.661 179.048 247.848 178.994 248.004 178.885C248.16 178.771 248.28 178.606 248.364 178.39C248.454 178.174 248.499 177.916 248.499 177.616C248.499 177.328 248.457 177.085 248.373 176.887C248.289 176.683 248.169 176.527 248.013 176.419C247.857 176.311 247.673 176.257 247.463 176.257C247.127 176.257 246.863 176.377 246.671 176.617C246.485 176.851 246.392 177.196 246.392 177.652C246.392 178.108 246.485 178.456 246.671 178.696C246.857 178.93 247.115 179.048 247.445 179.048ZM253.116 179.993C252.642 179.993 252.228 179.9 251.874 179.714C251.526 179.528 251.256 179.261 251.064 178.912C250.872 178.564 250.776 178.144 250.776 177.652C250.776 177.16 250.872 176.74 251.064 176.392C251.256 176.044 251.523 175.776 251.865 175.59C252.213 175.404 252.609 175.311 253.053 175.311C253.51 175.311 253.897 175.404 254.215 175.59C254.533 175.77 254.776 176.02 254.944 176.338C255.112 176.65 255.196 177.007 255.196 177.409C255.196 177.529 255.193 177.643 255.187 177.751C255.181 177.859 255.172 177.955 255.16 178.039H251.568V177.184H254.62L254.026 177.4C254.026 177.022 253.939 176.731 253.765 176.527C253.597 176.323 253.357 176.221 253.044 176.221C252.816 176.221 252.618 176.275 252.45 176.383C252.288 176.491 252.165 176.653 252.081 176.869C251.997 177.079 251.955 177.346 251.955 177.67C251.955 177.988 252 178.252 252.09 178.462C252.186 178.666 252.318 178.819 252.486 178.921C252.66 179.024 252.867 179.075 253.107 179.075C253.372 179.075 253.585 179.024 253.747 178.921C253.909 178.819 254.035 178.678 254.125 178.498L255.106 178.876C255.01 179.111 254.863 179.312 254.665 179.48C254.473 179.648 254.242 179.777 253.972 179.867C253.708 179.951 253.423 179.993 253.116 179.993Z",
    fill: "black",
    opacity: 1.0,
  },
  {
    type: "path",
    d: "M5.54606 173.959L3.43939 177.677V179.901H2.197V177.677L0.090332 173.959H1.41375L2.36805 175.741L2.81819 176.669L3.27734 175.741L4.23164 173.959H5.54606ZM7.47514 175.309C7.93129 175.309 8.33041 175.402 8.67252 175.588C9.02063 175.774 9.29072 176.042 9.48278 176.39C9.68084 176.738 9.77987 177.158 9.77987 177.65C9.77987 178.136 9.68084 178.556 9.48278 178.91C9.29072 179.259 9.02063 179.526 8.67252 179.712C8.33041 179.898 7.93129 179.991 7.47514 179.991C7.025 179.991 6.62587 179.898 6.27776 179.712C5.92964 179.526 5.65655 179.259 5.45849 178.91C5.26643 178.556 5.1704 178.136 5.1704 177.65C5.1704 177.158 5.26643 176.738 5.45849 176.39C5.65655 176.042 5.92964 175.774 6.27776 175.588C6.62587 175.402 7.025 175.309 7.47514 175.309ZM7.47514 176.228C7.24707 176.228 7.05201 176.282 6.88996 176.39C6.73391 176.492 6.61387 176.648 6.52984 176.858C6.44582 177.068 6.4038 177.332 6.4038 177.65C6.4038 177.968 6.44582 178.232 6.52984 178.442C6.61387 178.652 6.73391 178.811 6.88996 178.919C7.05201 179.022 7.24707 179.073 7.47514 179.073C7.69721 179.073 7.88627 179.022 8.04232 178.919C8.20437 178.811 8.32741 178.652 8.41144 178.442C8.49547 178.232 8.53748 177.968 8.53748 177.65C8.53748 177.332 8.49547 177.068 8.41144 176.858C8.32741 176.648 8.20437 176.492 8.04232 176.39C7.88627 176.282 7.69721 176.228 7.47514 176.228ZM12.3784 179.991C12.0783 179.991 11.8082 179.937 11.5681 179.829C11.3281 179.721 11.136 179.55 10.992 179.316C10.8539 179.076 10.7849 178.766 10.7849 178.388V175.399H12.0183V178.091C12.0183 178.439 12.0903 178.682 12.2343 178.82C12.3784 178.952 12.5855 179.019 12.8555 179.019C12.9816 179.019 13.1046 178.998 13.2247 178.955C13.3447 178.907 13.4497 178.835 13.5398 178.739C13.6358 178.643 13.7108 178.52 13.7648 178.37C13.8189 178.214 13.8459 178.031 13.8459 177.821V175.399H15.0792V179.901H13.9809L13.9359 179.118C13.7858 179.418 13.5788 179.64 13.3147 179.784C13.0566 179.922 12.7445 179.991 12.3784 179.991ZM16.3771 179.901V175.399H17.4484L17.5294 176.282C17.6495 175.97 17.8235 175.729 18.0516 175.561C18.2857 175.393 18.5768 175.309 18.9249 175.309C19.0269 175.309 19.1199 175.318 19.204 175.336C19.288 175.354 19.357 175.378 19.411 175.408L19.267 176.444C19.207 176.42 19.132 176.402 19.0419 176.39C18.9579 176.378 18.8469 176.372 18.7088 176.372C18.5288 176.372 18.3547 176.417 18.1867 176.507C18.0186 176.591 17.8806 176.723 17.7725 176.903C17.6645 177.077 17.6105 177.299 17.6105 177.569V179.901H16.3771ZM22.76 179.901V175.399H23.8314L23.9124 176.282C24.0324 175.97 24.2065 175.729 24.4346 175.561C24.6686 175.393 24.9597 175.309 25.3078 175.309C25.4099 175.309 25.5029 175.318 25.5869 175.336C25.6709 175.354 25.74 175.378 25.794 175.408L25.6499 176.444C25.5899 176.42 25.5149 176.402 25.4249 176.39C25.3408 176.378 25.2298 176.372 25.0918 176.372C24.9117 176.372 24.7377 176.417 24.5696 176.507C24.4015 176.591 24.2635 176.723 24.1555 176.903C24.0474 177.077 23.9934 177.299 23.9934 177.569V179.901H22.76ZM27.1793 174.751C26.9212 174.751 26.7292 174.697 26.6031 174.589C26.4771 174.475 26.4141 174.31 26.4141 174.094C26.4141 173.872 26.4771 173.707 26.6031 173.599C26.7292 173.485 26.9212 173.428 27.1793 173.428C27.4374 173.428 27.6294 173.485 27.7555 173.599C27.8815 173.707 27.9445 173.872 27.9445 174.094C27.9445 174.31 27.8815 174.475 27.7555 174.589C27.6294 174.697 27.4374 174.751 27.1793 174.751ZM27.7915 175.399V179.901H26.5581V175.399H27.7915ZM33.2492 174.328L33.3933 175.21C33.3693 175.21 33.3423 175.21 33.3123 175.21C33.2883 175.204 33.2612 175.201 33.2312 175.201C32.9552 175.201 32.7481 175.264 32.61 175.39C32.472 175.51 32.403 175.678 32.403 175.895L31.8988 175.687C31.8988 175.447 31.9468 175.225 32.0429 175.021C32.1389 174.811 32.2799 174.643 32.466 174.517C32.6581 174.391 32.8861 174.328 33.1502 174.328C33.1622 174.328 33.1772 174.328 33.1952 174.328C33.2132 174.328 33.2312 174.328 33.2492 174.328ZM31.7728 179.055C32.2589 179.055 32.634 179.16 32.8981 179.37C33.1622 179.58 33.2943 179.874 33.2943 180.252C33.2943 180.594 33.1952 180.882 32.9972 181.116C32.7991 181.356 32.52 181.536 32.1599 181.656C31.8058 181.776 31.3947 181.836 30.9265 181.836C30.1523 181.836 29.5851 181.728 29.225 181.512C28.8709 181.296 28.6938 181.014 28.6938 180.666C28.6938 180.42 28.7868 180.213 28.9729 180.045C29.165 179.877 29.4801 179.784 29.9182 179.766L29.8732 179.91C29.5611 179.856 29.321 179.754 29.1529 179.604C28.9909 179.448 28.9099 179.235 28.9099 178.964C28.9099 178.688 29.0149 178.463 29.225 178.289C29.441 178.109 29.7321 178.004 30.0982 177.974L30.6384 178.226H30.5124C30.2543 178.244 30.0712 178.298 29.9632 178.388C29.8612 178.472 29.8102 178.568 29.8102 178.676C29.8102 178.802 29.8582 178.898 29.9542 178.964C30.0562 179.025 30.2003 179.055 30.3863 179.055H31.7728ZM30.9355 180.99C31.2476 180.99 31.5027 180.963 31.7008 180.909C31.9048 180.855 32.0549 180.786 32.1509 180.702C32.2529 180.618 32.3039 180.525 32.3039 180.423C32.3039 180.309 32.2589 180.216 32.1689 180.144C32.0789 180.078 31.9168 180.045 31.6828 180.045H30.1613C30.0172 180.045 29.8972 180.081 29.8012 180.153C29.7111 180.225 29.6661 180.324 29.6661 180.45C29.6661 180.618 29.7771 180.75 29.9992 180.846C30.2273 180.942 30.5394 180.99 30.9355 180.99ZM30.9445 175.309C31.3646 175.309 31.7278 175.372 32.0339 175.498C32.346 175.618 32.583 175.792 32.7451 176.021C32.9131 176.249 32.9972 176.522 32.9972 176.84C32.9972 177.152 32.9131 177.422 32.7451 177.65C32.583 177.878 32.346 178.055 32.0339 178.181C31.7278 178.301 31.3646 178.361 30.9445 178.361C30.2783 178.361 29.7681 178.226 29.414 177.956C29.0659 177.68 28.8919 177.308 28.8919 176.84C28.8919 176.522 28.9729 176.249 29.1349 176.021C29.303 175.792 29.5401 175.618 29.8462 175.498C30.1523 175.372 30.5184 175.309 30.9445 175.309ZM30.9445 176.084C30.7044 176.084 30.5064 176.15 30.3503 176.282C30.1943 176.414 30.1163 176.597 30.1163 176.831C30.1163 177.065 30.1943 177.251 30.3503 177.389C30.5064 177.521 30.7044 177.587 30.9445 177.587C31.1846 177.587 31.3797 177.521 31.5297 177.389C31.6858 177.251 31.7638 177.065 31.7638 176.831C31.7638 176.597 31.6858 176.414 31.5297 176.282C31.3797 176.15 31.1846 176.084 30.9445 176.084ZM34.0399 179.901V173.428H35.2733V176.165C35.4174 175.877 35.6154 175.663 35.8675 175.525C36.1196 175.381 36.4047 175.309 36.7228 175.309C37.0349 175.309 37.311 175.369 37.551 175.489C37.7971 175.609 37.9892 175.792 38.1272 176.039C38.2713 176.279 38.3433 176.582 38.3433 176.948V179.901H37.1099V177.308C37.1099 176.918 37.0349 176.651 36.8848 176.507C36.7348 176.357 36.5427 176.282 36.3086 176.282C36.1346 176.282 35.9665 176.324 35.8045 176.408C35.6484 176.486 35.5194 176.618 35.4174 176.804C35.3213 176.984 35.2733 177.224 35.2733 177.524V179.901H34.0399ZM41.1723 174.022V178.433C41.1723 178.649 41.2263 178.808 41.3343 178.91C41.4484 179.006 41.6014 179.055 41.7935 179.055C41.9435 179.055 42.0756 179.034 42.1896 178.991C42.3036 178.943 42.4057 178.88 42.4957 178.802L42.6938 179.622C42.5497 179.736 42.3697 179.826 42.1536 179.892C41.9375 179.958 41.7094 179.991 41.4694 179.991C41.1693 179.991 40.9022 179.946 40.6681 179.856C40.44 179.766 40.26 179.622 40.1279 179.424C40.0019 179.226 39.9389 178.961 39.9389 178.631V174.364L41.1723 174.022ZM42.6127 175.399V176.318H39.1106V175.399H42.6127ZM47.9996 179.991C47.5434 179.991 47.1263 179.91 46.7482 179.748C46.3761 179.586 46.073 179.358 45.8389 179.064L46.5501 178.343C46.6942 178.559 46.8862 178.736 47.1263 178.874C47.3664 179.013 47.6515 179.082 47.9816 179.082C48.2157 179.082 48.4017 179.049 48.5398 178.982C48.6838 178.91 48.7558 178.799 48.7558 178.649C48.7558 178.553 48.7228 178.472 48.6568 178.406C48.5908 178.334 48.4587 178.277 48.2607 178.235L47.4684 178.073C46.9463 177.965 46.5741 177.803 46.3521 177.587C46.136 177.365 46.028 177.08 46.028 176.732C46.028 176.486 46.1 176.255 46.244 176.039C46.3941 175.822 46.6161 175.648 46.9102 175.516C47.2043 175.378 47.5704 175.309 48.0086 175.309C48.4587 175.309 48.8489 175.381 49.179 175.525C49.5151 175.663 49.7791 175.871 49.9712 176.147L49.233 176.867C49.1009 176.657 48.9269 176.498 48.7108 176.39C48.5007 176.276 48.2787 176.219 48.0446 176.219C47.8765 176.219 47.7325 176.237 47.6125 176.273C47.4924 176.309 47.4024 176.36 47.3424 176.426C47.2824 176.486 47.2524 176.564 47.2524 176.66C47.2524 176.756 47.2944 176.84 47.3784 176.912C47.4624 176.978 47.6155 177.035 47.8375 177.083L48.7558 177.272C49.2 177.362 49.5181 177.515 49.7101 177.731C49.9022 177.941 49.9982 178.196 49.9982 178.496C49.9982 178.784 49.9202 179.043 49.7641 179.271C49.6141 179.493 49.389 179.67 49.0889 179.802C48.7948 179.928 48.4317 179.991 47.9996 179.991ZM51.603 174.751C51.3449 174.751 51.1528 174.697 51.0268 174.589C50.9008 174.475 50.8377 174.31 50.8377 174.094C50.8377 173.872 50.9008 173.707 51.0268 173.599C51.1528 173.485 51.3449 173.428 51.603 173.428C51.8611 173.428 52.0531 173.485 52.1792 173.599C52.3052 173.707 52.3682 173.872 52.3682 174.094C52.3682 174.31 52.3052 174.475 52.1792 174.589C52.0531 174.697 51.8611 174.751 51.603 174.751ZM52.2152 175.399V179.901H50.9818V175.399H52.2152ZM55.2242 179.991C54.8521 179.991 54.519 179.898 54.2249 179.712C53.9368 179.526 53.7087 179.259 53.5407 178.91C53.3786 178.562 53.2976 178.145 53.2976 177.659C53.2976 177.161 53.3846 176.738 53.5587 176.39C53.7327 176.036 53.9668 175.768 54.2609 175.588C54.561 175.402 54.8971 175.309 55.2692 175.309C55.6654 175.309 55.9925 175.423 56.2505 175.651C56.5086 175.88 56.6767 176.174 56.7547 176.534L56.6377 176.678V173.428H57.8711V179.901H56.7637L56.6827 178.532L56.8357 178.604C56.7937 178.886 56.6977 179.133 56.5476 179.343C56.3976 179.547 56.2085 179.706 55.9805 179.82C55.7524 179.934 55.5003 179.991 55.2242 179.991ZM55.5843 179.046C55.8004 179.046 55.9865 178.991 56.1425 178.883C56.2986 178.769 56.4186 178.604 56.5026 178.388C56.5927 178.172 56.6377 177.914 56.6377 177.614C56.6377 177.326 56.5957 177.083 56.5116 176.885C56.4276 176.681 56.3076 176.525 56.1515 176.417C55.9955 176.309 55.8124 176.255 55.6023 176.255C55.2662 176.255 55.0021 176.375 54.8101 176.615C54.624 176.849 54.531 177.194 54.531 177.65C54.531 178.106 54.624 178.454 54.8101 178.694C54.9961 178.928 55.2542 179.046 55.5843 179.046ZM61.2557 179.991C60.7815 179.991 60.3674 179.898 60.0133 179.712C59.6652 179.526 59.3951 179.259 59.203 178.91C59.011 178.562 58.9149 178.142 58.9149 177.65C58.9149 177.158 59.011 176.738 59.203 176.39C59.3951 176.042 59.6622 175.774 60.0043 175.588C60.3524 175.402 60.7485 175.309 61.1927 175.309C61.6488 175.309 62.0359 175.402 62.354 175.588C62.6721 175.768 62.9152 176.018 63.0833 176.336C63.2513 176.648 63.3353 177.005 63.3353 177.407C63.3353 177.527 63.3323 177.641 63.3263 177.749C63.3203 177.857 63.3113 177.953 63.2993 178.037H59.7072V177.182H62.7592L62.165 177.398C62.165 177.02 62.0779 176.729 61.9039 176.525C61.7358 176.321 61.4958 176.219 61.1837 176.219C60.9556 176.219 60.7575 176.273 60.5895 176.381C60.4274 176.489 60.3044 176.651 60.2203 176.867C60.1363 177.077 60.0943 177.344 60.0943 177.668C60.0943 177.986 60.1393 178.25 60.2294 178.46C60.3254 178.664 60.4574 178.817 60.6255 178.919C60.7995 179.022 61.0066 179.073 61.2467 179.073C61.5108 179.073 61.7238 179.022 61.8859 178.919C62.0479 178.817 62.174 178.676 62.264 178.496L63.2453 178.874C63.1493 179.109 63.0022 179.31 62.8042 179.478C62.6121 179.646 62.381 179.775 62.1109 179.865C61.8469 179.949 61.5618 179.991 61.2557 179.991Z",
    fill: "black",
    opacity: 1.0,
  },
];